const navigation = {
  'navigation.section.collect': '收集',
  'navigation.section.process': '处理',
  'navigation.section.create': '创作',
  'navigation.section.work': '工作',
  'navigation.section.manage': '管理',
  'navigation.item.sources': '数据源',
  'navigation.item.materials': '资源库',
  'navigation.item.notebooks': '笔记本',
  'navigation.item.search': '提问与搜索',
  'navigation.item.image_generator': '图片生成',
  'navigation.item.podcasts': '播客',
  'navigation.item.digital_employees': '数字员工',
  'navigation.item.agents': '智能体',
  'navigation.item.workflows': '工作流',
  'navigation.item.models': '模型',
  'navigation.item.transformations': '转换',
  'navigation.item.settings': '设置',
  'navigation.item.advanced': '高级',
  'navigation.item.member_center': '会员中心',
  'navigation.create': '新建',
  'navigation.create.digital_employees': '数字员工',
  'navigation.create.source': '数据源',
  'navigation.create.notebook': '笔记本',
  'navigation.create.image_generator': '图片生成',
  'navigation.create.podcast': '播客',
  'navigation.create.tooltip': '新建',
  'navigation.backToNotebook': '返回笔记本',
  'navigation.backToSources': '返回数据源',
}

const controls = {
  'controls.theme': '主题',
  'controls.quickActions': '快捷操作',
  'controls.quickActionsHint': '导航、搜索、提问、主题',
  'controls.signOut': '退出登录',
}

const user = {
  'user.menuTitle': '用户',
  'user.systemLabel': '系统',
  'user.systemTooltip': '当前租户：{system}',
  'user.systemUnknown': '未知系统',
  'user.tenantUnknown': '未知租户',
  'user.spaceUnknown': '未知空间',
  'user.spaceLabel': '空间',
  'user.roleLabel': '角色',
  'user.switchTenant': '切换租户',
  'user.role.owner': '所有者',
  'user.role.admin': '管理员',
  'user.role.employee': '员工',
  'user.role.unknown': '未知角色',
}

const settingsLanguage = {
  'settings.title': '设置',
  'settings.language.title': '界面语言',
  'settings.language.description': '选择控制台界面的显示语言',
  'settings.language.note': '切换后导航与常用控件立即更新。',
  'settings.language.en': 'English',
  'settings.language.zh': '中文',
}

const settingsActions = {
  'settings.actions.save': '保存设置',
  'settings.actions.saving': '保存中...',
}

const settingsCommon = {
  'settings.common.helpMeChoose': '帮我选择',
  'settings.load.errorTitle': '加载设置失败',
  'settings.load.errorUnexpected': '发生未知错误。',
  'common.all': '全部',
}

const settingsContentProcessing = {
  'settings.content.title': '内容处理',
  'settings.content.description': '配置文档与链接的处理方式',
  'settings.content.doc.label': '文档处理引擎',
  'settings.content.doc.placeholder': '选择文档处理引擎',
  'settings.content.doc.option.auto': '自动（推荐）',
  'settings.content.doc.option.docling': 'Docling',
  'settings.content.doc.option.simple': '简单模式',
  'settings.content.doc.help.docling': 'Docling 略慢但更精准，特别适合包含表格或图片的文档。',
  'settings.content.doc.help.simple': '简单模式会直接提取文本，不做格式化，适合简单文档，复杂文档可能会丢失质量。',
  'settings.content.doc.help.auto': '自动（推荐）会优先尝试 Docling，失败时回退到简单模式。',
  'settings.content.url.label': '链接处理引擎',
  'settings.content.url.placeholder': '选择链接处理引擎',
  'settings.content.url.option.auto': '自动（推荐）',
  'settings.content.url.option.firecrawl': 'Firecrawl',
  'settings.content.url.option.jina': 'Jina',
  'settings.content.url.option.simple': '简单模式',
  'settings.content.url.help.firecrawl': 'Firecrawl 功能强大，需付费但有免费额度。',
  'settings.content.url.help.jina': 'Jina 也是不错的选择，并提供免费额度。',
  'settings.content.url.help.simple': '简单模式使用基础 HTTP 抓取，对依赖 JavaScript 的站点可能遗漏内容。',
  'settings.content.url.help.auto':
    '自动（推荐）会优先尝试 Firecrawl（如果 API Key 存在），然后使用 Jina 直到达到限制（或者如果设置了 API Key 则继续使用 Jina）。当以上选项均不可用时，将回退到简单模式。',
}

const settingsEmbedding = {
  'settings.embedding.title': '向量与搜索',
  'settings.embedding.description': '配置搜索与向量化选项',
  'settings.embedding.label': '默认向量化选项',
  'settings.embedding.placeholder': '选择向量化策略',
  'settings.embedding.option.ask': '每次询问',
  'settings.embedding.option.always': '始终向量化',
  'settings.embedding.option.never': '不向量化',
  'settings.embedding.help.intro':
    '向量化有助于你和智能体更好地发现内容。如果你在本地运行向量模型（例如 Ollama），几乎没有成本，可直接全部向量化。使用在线服务时，只有在大批量处理（每天上百份）时需要关注成本。',
  'settings.embedding.help.always': '如果你使用本地模型或内容量不大，推荐选择“始终向量化”。',
  'settings.embedding.help.ask': '如果希望每次手动决定，选择“每次询问”。',
  'settings.embedding.help.never': '如果不关心向量搜索或没有向量服务，选择“不向量化”。',
  'settings.embedding.help.cost':
    '参考：OpenAI text-embedding-3-small 每百万 tokens 约 $0.02（约 30 篇地球词条）。Gemini API 的 Text Embedding 004 免费，速率 1500 请求/分钟。',
}

const settingsFiles = {
  'settings.files.title': '文件管理',
  'settings.files.description': '配置文件处理与存储策略',
  'settings.files.label': '自动删除文件',
  'settings.files.placeholder': '选择是否自动删除',
  'settings.files.option.yes': '是',
  'settings.files.option.no': '否',
  'settings.files.help.intro':
    '文件上传并处理完成后通常不再需要。大多数用户都应允许自动删除上传文件。只有当 Notebook 被当作主存储（并不推荐）时才需要保留。未来可能改为总是下载后删除。',
  'settings.files.help.yes': '推荐选择“是”，处理后自动删除上传文件。',
  'settings.files.help.no': '只有确实需要保留原文件时才选择“否”。',
}

const notebooksPage = {
  'notebooks.page.title': '笔记本',
  'notebooks.page.searchPlaceholder': '搜索笔记本...',
  'notebooks.page.create': '新建笔记本',
  'notebooks.page.activeTitle': '活跃笔记本',
  'notebooks.page.archivedTitle': '已归档笔记本',
  'notebooks.page.empty.searchActiveTitle': '没有符合搜索的笔记本',
  'notebooks.page.empty.searchActiveDescription': '尝试使用不同的笔记本名称。',
  'notebooks.page.empty.searchArchivedTitle': '没有符合搜索的已归档笔记本',
  'notebooks.page.empty.searchArchivedDescription': '调整搜索以找到已归档的笔记本。',
}

const notebooksList = {
  'notebooks.list.empty.title': '暂无笔记本',
  'notebooks.list.empty.description': '创建第一个笔记本来组织你的研究内容。',
}

const notebooksCard = {
  'notebooks.card.archived': '已归档',
  'notebooks.card.unarchive': '取消归档',
  'notebooks.card.archive': '归档',
  'notebooks.card.delete': '删除',
  'notebooks.card.noDescription': '暂无描述',
  'notebooks.card.updated': '更新于',
  'notebooks.card.confirm.title': '删除笔记本',
  'notebooks.card.confirm.description':
    '确定要删除 “{name}” 吗？此操作不可撤销，将删除所有来源、笔记和对话会话。',
  'notebooks.card.confirm.cta': '删除',
}

const notebooksHeader = {
  'notebooks.header.namePlaceholder': '笔记本名称',
  'notebooks.header.archivedBadge': '已归档',
  'notebooks.header.unarchive': '取消归档',
  'notebooks.header.archive': '归档',
  'notebooks.header.knowledgeGraph': '知识图谱',
  'notebooks.header.knowledgeGraphComingSoon': '暂不开放，敬请期待',
  'notebooks.header.delete': '删除',
  'notebooks.header.descriptionPlaceholder': '添加描述...',
  'notebooks.header.descriptionEmpty': '添加描述...',
  'notebooks.header.meta.created': '创建于',
  'notebooks.header.meta.updated': '更新于',
  'notebooks.header.confirm.title': '删除笔记本',
  'notebooks.header.confirm.description':
    '确定要删除 “{name}” 吗？此操作不可撤销，将删除所有来源、笔记和对话会话。',
  'notebooks.header.confirm.cta': '永久删除',
}

const notebooksDetail = {
  'notebooks.detail.notFoundTitle': '未找到笔记本',
  'notebooks.detail.notFoundDescription': '请求的笔记本不存在。',
  'notebooks.detail.tabs.sources': '来源',
  'notebooks.detail.tabs.notes': '笔记',
  'notebooks.detail.tabs.chat': '对话',
}

const notebooksKnowledgeGraph = {
  'notebooks.knowledgeGraph.title': '知识图谱',
  'notebooks.knowledgeGraph.description': '笔记本 {notebookId} 的知识图谱。',
}

const notebooksSources = {
  'notebooks.sources.collapsedLabel': '来源',
  'notebooks.sources.title': '来源',
  'notebooks.sources.add': '添加来源',
  'notebooks.sources.addNew': '添加新来源',
  'notebooks.sources.addExisting': '关联已有来源',
  'notebooks.sources.empty.title': '暂无来源',
  'notebooks.sources.empty.description': '添加第一个来源，开始构建你的知识库。',
  'notebooks.sources.delete.title': '删除来源',
  'notebooks.sources.delete.description': '确定要删除此来源吗？此操作不可撤销。',
  'notebooks.sources.delete.cta': '删除',
  'notebooks.sources.remove.title': '从笔记本移除来源',
  'notebooks.sources.remove.description': '确定要将此来源从笔记本移除吗？来源本身不会被删除。',
  'notebooks.sources.remove.cta': '移除',
}

const notebooksNotes = {
  'notebooks.notes.collapsedLabel': '笔记',
  'notebooks.notes.title': '笔记',
  'notebooks.notes.add': '撰写笔记',
  'notebooks.notes.empty.title': '暂无笔记',
  'notebooks.notes.empty.description': '创建第一条笔记来记录洞见与观察。',
  'notebooks.notes.badge.ai': 'AI 生成',
  'notebooks.notes.badge.human': '人工',
  'notebooks.notes.delete.title': '删除笔记',
  'notebooks.notes.delete.description': '确定要删除这条笔记吗？此操作不可撤销。',
  'notebooks.notes.delete.cta': '删除',
}

const notebooksChat = {
  'notebooks.chat.title': '笔记本对话',
  'notebooks.chat.title.source': '与数据源对话',
  'notebooks.chat.error.title': '无法加载对话',
  'notebooks.chat.error.hint': '请尝试刷新页面',
  'notebooks.chat.error.notFound': '找不到此{type}',
  'notebooks.chat.empty.start': '开始关于此{contextType}的对话',
  'notebooks.chat.empty.hint': '提出问题以更好地理解内容',
  'notebooks.chat.input.placeholder': '提出关于此{contextType}的问题...',
  'notebooks.chat.input.send': '发送',
  'notebooks.chat.sessions': '会话',
  'notebooks.chat.sessions.title': '对话会话',
  'notebooks.chat.sessions.loading': '正在加载会话...',
  'notebooks.chat.sessions.empty': '暂无对话会话',
  'notebooks.chat.sessions.emptyHint': '创建一个会话开始对话',
  'notebooks.chat.sessions.create': '创建',
  'notebooks.chat.sessions.cancel': '取消',
  'notebooks.chat.sessions.placeholder': '会话标题...',
  'notebooks.chat.sessions.messages': '{count} 条消息',
  'notebooks.chat.sessions.delete.title': '删除对话会话？',
  'notebooks.chat.sessions.delete.description': '此操作不可撤销。此会话中的所有消息都将被永久删除。',
  'notebooks.chat.sessions.delete.confirm': '删除',
  'notebooks.chat.model.label': '模型',
  'notebooks.chat.context.source': '数据源',
  'notebooks.chat.context.sources': '数据源',
  'notebooks.chat.context.insight': '洞见',
  'notebooks.chat.context.insights': '洞见',
  'notebooks.chat.context.note': '笔记',
  'notebooks.chat.context.notes': '笔记',
  'notebooks.chat.context.notebook': '笔记本',
  'notebooks.chat.context.notebooks': '笔记本',
  'notebooks.chat.references': '参考资料',
}

const notebooksEditor = {
  'notebooks.editor.editTitle': '编辑笔记',
  'notebooks.editor.createTitle': '创建笔记',
  'notebooks.editor.placeholder.title': '添加标题...',
  'notebooks.editor.placeholder.untitled': '无标题笔记',
  'notebooks.editor.placeholder.content': '在这里撰写笔记内容...',
  'notebooks.editor.loading': '正在加载笔记…',
  'notebooks.editor.actions.cancel': '取消',
  'notebooks.editor.actions.saving': '保存中...',
  'notebooks.editor.actions.creating': '创建中...',
  'notebooks.editor.actions.save': '保存笔记',
  'notebooks.editor.actions.create': '创建笔记',
  'notebooks.editor.validation.contentRequired': '内容不能为空',
}

const notebookAssociations = {
  'notebookAssociations.title': '笔记本',
  'notebookAssociations.description': '管理包含此来源的笔记本',
  'notebookAssociations.noNotebooks': '暂无笔记本',
  'notebookAssociations.save': '保存更改',
}

const commonCommandPalette = {
  'commandPalette.title': '命令面板',
  'commandPalette.description': '导航、搜索或向知识库提问',
  'commandPalette.placeholder': '输入命令或搜索内容...',
  'commandPalette.section.searchAsk': '搜索与提问',
  'commandPalette.section.navigation': '导航',
  'commandPalette.section.notebooks': '笔记本',
  'commandPalette.section.create': '新建',
  'commandPalette.section.theme': '主题',
  'commandPalette.section.searchPrompt': '或搜索你的知识库',
  'commandPalette.search.label': '搜索 “{query}”',
  'commandPalette.ask.label': '提问 “{query}”',
  'commandPalette.notebooks.loading': '正在加载笔记本...',
  'commandPalette.create.source': '新建来源',
  'commandPalette.create.notebook': '新建笔记本',
  'commandPalette.create.podcast': '新建播客',
  'commandPalette.theme.light': '浅色主题',
  'commandPalette.theme.dark': '深色主题',
  'commandPalette.theme.system': '跟随系统',
}

const commonAddButton = {
  'addButton.add': '添加',
  'addButton.source': '来源',
  'addButton.notebook': '笔记本',
  'addButton.notebook.soon': '即将推出',
}

const commonTheme = {
  'theme.toggle.label': '主题',
  'theme.toggle.sr': '切换主题',
  'theme.option.light': '浅色',
  'theme.option.dark': '深色',
  'theme.option.system': '系统',
}

const commonActions = {
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.stay_tuned': '敬请期待',
  'common.loading': '加载中...',
  'common.save': '保存',
  'common.saving': '保存中...',
  'common.auto_refresh_on': '自动刷新已开启',
  'common.auto_refresh_off': '自动刷新已关闭',
}

const commonConfirmDialog = {
  'confirmDialog.confirm': '确认',
  'confirmDialog.cancel': '取消',
}

const commonErrorBoundary = {
  'errorBoundary.title': '出现了一些问题',
  'errorBoundary.description': '发生了意外错误，请尝试刷新页面。',
  'errorBoundary.details': '错误详情',
  'errorBoundary.tryAgain': '重试',
  'errorBoundary.refresh': '刷新页面',
}

const commonConnection = {
  'connection.api.unreachable.title': '无法连接到 API 服务器',
  'connection.api.unreachable.subtitle': '无法访问 FishOwn Agent API 服务器',
  'connection.db.offline.title': '数据库连接失败',
  'connection.db.offline.subtitle': 'API 服务器已运行，但数据库无法访问',
  'connection.guide.heading': '通常意味着：',
  'connection.guide.api.item1': 'API 服务器未运行',
  'connection.guide.api.item2': 'API 服务器运行在其他地址',
  'connection.guide.api.item3': '网络连接问题',
  'connection.guide.db.item1': 'SurrealDB 未运行',
  'connection.guide.db.item2': '数据库连接配置错误',
  'connection.guide.db.item3': 'API 与数据库之间的网络问题',
  'connection.guide.quick.heading': '快速排查：',
  'connection.quick.api.title': '设置 API_URL 环境变量：',
  'connection.quick.db.title': '检查 SurrealDB 是否运行：',
  'connection.docs.prefix': '更多部署/配置说明参见：',
  'connection.docs.link': 'FishOwn Agent 文档',
  'connection.details.toggle': '展开技术细节',
  'connection.details.attemptedUrl': '请求地址：',
  'connection.details.message': '提示信息：',
  'connection.details.technical': '技术细节：',
  'connection.details.stack': '堆栈：',
  'connection.retry': '重试连接',
  'connection.retry.hint': '按 R 或点击按钮重试',
}

const commonModelSelector = {
  'modelSelector.placeholder': '选择一个模型',
  'modelSelector.empty.language': '暂无语言模型',
  'modelSelector.empty.embedding': '暂无向量模型',
  'modelSelector.empty.speech_to_text': '暂无语音转文本模型',
  'modelSelector.empty.text_to_speech': '暂无文本转语音模型',
  'modelSelector.empty.generic': '暂无可用模型',
}

const modelSelectorDialog = {
  'modelSelector.dialog.title': '模型配置',
  'modelSelector.dialog.description': '为此聊天会话覆盖默认模型。留空以使用系统默认值。',
  'modelSelector.dialog.label': '模型',
  'modelSelector.dialog.placeholder': '选择一个模型（或使用默认值）',
  'modelSelector.dialog.defaultWithModel': '默认 ({model})',
  'modelSelector.dialog.systemDefault': '系统默认',
  'modelSelector.dialog.usingCustom': '此会话将使用 <strong>{model}</strong> 而不是默认模型。',
  'modelSelector.dialog.reset': '重置为默认',
  'modelSelector.dialog.save': '保存更改',
  'modelSelector.dialog.defaultModel': '默认模型',
}

const commonContextToggle = {
  'contextToggle.off': '不参与对话',
  'contextToggle.insights': '仅用洞见',
  'contextToggle.full': '使用全文',
  'contextToggle.cycle': '点击切换',
}

const commonContextIndicator = {
  'contextIndicator.empty': '当前对话未包含任何来源或笔记，点击卡片图标可将其加入上下文。',
  'contextIndicator.label': '上下文：',
  'contextIndicator.tooltip.insights': '{count} 个来源的洞见',
  'contextIndicator.tooltip.sources': '{count} 个来源全文',
  'contextIndicator.tooltip.notes': '{count} 条笔记全文',
  'contextIndicator.tokens': '{count} tokens',
  'contextIndicator.chars': '{count} 字符',
}

const searchPage = {
  'search.page.title': '提问与搜索',
  'search.page.mode.label': '选择模式',
  'search.page.mode.ariaLabel': '向知识库提问或搜索',
  'search.page.mode.ask': '提问 (beta)',
  'search.page.mode.search': '搜索',
  'search.ask.title': '向知识库提问 (beta)',
  'search.ask.description': 'LLM 将根据你知识库中的文档来回答问题。',
  'search.ask.question.label': '问题',
  'search.ask.question.placeholder': '输入你的问题...',
  'search.ask.question.shortcut': '按 Cmd/Ctrl+Enter 提交',
  'search.ask.error.noEmbeddingModel': '你尚未选择向量模型，无法使用此功能。请在“模型”页面中设置。',
  'search.ask.models.custom': '使用自定义模型',
  'search.ask.models.default': '使用默认模型',
  'search.ask.models.advanced': '高级',
  'search.ask.models.strategy': '策略: {model}',
  'search.ask.models.answer': '回答: {model}',
  'search.ask.models.final': '最终: {model}',
  'search.ask.models.notSet': '未设置',
  'search.ask.actions.processing': '处理中...',
  'search.ask.actions.ask': '提问',
  'search.ask.actions.saveToNotebook': '保存到笔记本',
  'search.search.title': '搜索',
  'search.search.description': '在知识库中搜索特定的关键词或概念',
  'search.search.query.placeholder': '输入搜索查询...',
  'search.search.actions.search': '搜索',
  'search.search.query.shortcut': '按 Enter 搜索',
  'search.search.options.type.label': '搜索类型',
  'search.search.options.type.noEmbeddingModel': '向量搜索需要向量模型。当前仅文本搜索可用。',
  'search.search.options.type.text': '文本搜索',
  'search.search.options.type.vector': '向量搜索',
  'search.search.options.location.label': '搜索范围',
  'search.search.options.location.sources': '搜索来源',
  'search.search.options.location.notes': '搜索笔记',
  'search.results.count': '找到 {count} 个结果',
  'search.results.type': '{type} 搜索',
  'search.results.empty': '未找到与 “{query}” 相关的结果',
  'search.results.matches': '匹配项 ({count})',
}

const sourcesPage = {
  'sources.page.title': '所有来源',
  'sources.page.description': '浏览所有笔记本中的来源。使用方向键导航，按 Enter 打开。',
  'sources.page.empty.title': '暂无来源',
  'sources.page.empty.description': '所有笔记本的来源都将在此处显示',
  'sources.page.error.load': '加载来源失败',
  'sources.page.error.delete': '删除来源失败',
  'sources.page.success.delete': '来源删除成功',
  'sources.page.table.type': '类型',
  'sources.page.table.title': '标题',
  'sources.page.table.created': '创建时间',
  'sources.page.table.insights': '洞见',
  'sources.page.table.embedded': '已向量化',
  'sources.page.table.actions': '操作',
  'sources.page.type.link': '链接',
  'sources.page.type.file': '文件',
  'sources.page.type.text': '文本',
  'sources.page.type.unknown': '未知',
  'sources.page.untitled': '无标题来源',
  'sources.page.embedded.yes': '是',
  'sources.page.embedded.no': '否',
  'sources.page.loadingMore': '正在加载更多来源...',
  'sources.page.delete.title': '删除来源',
  'sources.page.delete.description': '确定要删除 “{title}” 吗？此操作不可撤销。',
  'sources.page.delete.cta': '删除',
}

const auth = {
  'auth.login.title': 'FishOwn Agent',
  'auth.login.description': '通过远端认证门户登录。',
  'auth.login.remote.iframeTitle': '远端身份验证门户',
  'auth.login.remote.waiting': '正在等待远端登录完成…',
  'auth.login.remote.missingUrl': '未配置远端登录 URL。',
  'auth.login.remote.missingUrlDescription': '请在启动 Dashboard 前设置 NEXT_PUBLIC_REMOTE_LOGIN_URL 指向远端登录页面。',
  'auth.login.passwordPlaceholder': '密码',
  'auth.login.signIn': '登录',
  'auth.login.signingIn': '登录中...',
  'auth.login.error.connection.title': '连接错误',
  'auth.login.error.connection.description': '无法连接到 API 服务器',
  'auth.login.error.connection.detailed': '无法连接到服务器。请检查 API 是否正在运行。',
  'auth.login.error.diagnostics.title': '诊断信息:',
  'auth.login.error.diagnostics.version': '版本: {version}',
  'auth.login.error.diagnostics.built': '构建于: {buildTime}',
  'auth.login.error.diagnostics.apiUrl': 'API URL: {apiUrl}',
  'auth.login.error.diagnostics.frontend': '前端: {url}',
  'auth.login.error.diagnostics.checkConsole': '查看浏览器控制台以获取详细日志 (寻找 🔧 [Config] 消息)',
  'auth.login.error.retry': '重试连接',
}

const imageGeneratorPage = {
  'image_generator.page.title': '图片生成',
  'image_generator.page.description': '使用多种 AI 模型生成图片。',
  'image_generator.tab.nano_banana_pro': 'Nano Banana Pro',
  'image_generator.tab.midjourney_v7': 'Midjourney V7',
}

const podcastsPage = {
  'podcasts.page.title': '播客',
  'podcasts.page.description': '跟踪生成的播客剧集并管理可复用的模板。',
  'podcasts.page.view.label': '选择视图',
  'podcasts.page.view.ariaLabel': '播客视图',
  'podcasts.page.view.episodes': '剧集',
  'podcasts.page.view.templates': '模板',
  'podcasts.episodes.title': '剧集概览',
  'podcasts.episodes.description': '监控播客生成任务并审查最终成品。',
  'podcasts.episodes.generate': '生成播客',
  'podcasts.episodes.refresh': '刷新',
  'podcasts.episodes.summary.total': '总计',
  'podcasts.episodes.summary.processing': '处理中',
  'podcasts.episodes.summary.completed': '已完成',
  'podcasts.episodes.summary.failed': '失败',
  'podcasts.episodes.summary.pending': '待处理',
  'podcasts.episodes.error.load.title': '加载剧集失败',
  'podcasts.episodes.error.load.description': '无法获取最新的播客剧集。请稍后重试。',
  'podcasts.episodes.loading': '正在加载剧集…',
  'podcasts.episodes.empty': '暂无播客剧集。请从笔记本或来源对话界面生成你的第一个剧集。',
  'podcasts.episodes.status.running.title': '正在处理',
  'podcasts.episodes.status.running.description': '正在积极生成资源的剧集。',
  'podcasts.episodes.status.pending.title': '排队/待处理',
  'podcasts.episodes.status.pending.description': '已提交并等待开始处理的剧集。',
  'podcasts.episodes.status.completed.title': '已完成的剧集',
  'podcasts.episodes.status.completed.description': '可供审查、下载或发布。',
  'podcasts.episodes.status.failed.title': '失败的剧集',
  'podcasts.episodes.status.failed.description': '生成过程中遇到问题的剧集。',
  'podcasts.templates.title': '模板工作区',
  'podcasts.templates.description': '构建可复用的剧集和演讲者配置，以实现快速播客制作。',
  'podcasts.templates.overview.title': '模板如何驱动播客生成',
  'podcasts.templates.overview.description': '模板将播客工作流分为两个可复用的构建块。在生成新剧集时，可以混合搭配它们。',
  'podcasts.templates.overview.episodeProfiles.title': '剧集配置设定格式',
  'podcasts.templates.overview.episodeProfiles.item1': '概述分段数量和故事流程',
  'podcasts.templates.overview.episodeProfiles.item2': '选择用于简报、大纲和脚本编写的语言模型',
  'podcasts.templates.overview.episodeProfiles.item3': '存储默认简报，使每集都以一致的基调开始',
  'podcasts.templates.overview.speakerProfiles.title': '演讲者配置赋予声音生命',
  'podcasts.templates.overview.speakerProfiles.item1': '选择文本转语音提供商和模型',
  'podcasts.templates.overview.speakerProfiles.item2': '捕捉每个演讲者的个性、背景故事和发音说明',
  'podcasts.templates.overview.speakerProfiles.item3': '在不同的剧集格式中复用相同的主持人或嘉宾声音',
  'podcasts.templates.overview.workflow.title': '推荐工作流',
  'podcasts.templates.overview.workflow.item1': '为你需要的每个声音创建演讲者配置',
  'podcasts.templates.overview.workflow.item2': '构建按名称引用这些演讲者的剧集配置',
  'podcasts.templates.overview.workflow.item3': '通过选择适合故事的剧集配置来生成播客',
  'podcasts.templates.overview.workflow.note': '剧集配置按名称引用演讲者配置，因此从演讲者开始可以避免稍后缺少声音分配。',
  'podcasts.templates.error.load.title': '加载模板数据失败',
  'podcasts.templates.error.load.description': '请确保 API 正在运行并重试。某些部分可能不完整。',
  'podcasts.templates.loading': '正在加载模板…',
}

const addSourceDialog = {
  'addSourceDialog.title': '添加新来源',
  'addSourceDialog.description': '从链接、上传或文本向笔记本添加内容。',
  'addSourceDialog.step1.title': '来源与内容',
  'addSourceDialog.step1.description': '选择类型并添加内容',
  'addSourceDialog.step2.title': '组织',
  'addSourceDialog.step2.description': '选择笔记本',
  'addSourceDialog.step3.title': '处理',
  'addSourceDialog.step3.description': '选择转换和选项',
  'addSourceDialog.validation.required': '请为所选来源类型提供必需的内容',
  'addSourceDialog.validation.titleRequired': '文本来源需要标题',
  'addSourceDialog.processing.batchMessage': '正在处理 {itemCount} 个来源...',
  'addSourceDialog.processing.batchSuccess': '成功创建 {successCount} 个来源',
  'addSourceDialog.processing.batchFailed': '创建所有 {failedCount} 个来源失败',
  'addSourceDialog.processing.batchPartial': '{successCount} 个成功, {failedCount} 个失败',
  'addSourceDialog.processing.singleMessage': '正在提交来源进行处理...',
  'addSourceDialog.processing.errorMessage': '创建来源时出错。请重试。',
  'addSourceDialog.processing.batchTitle': '正在处理批次',
  'addSourceDialog.processing.singleTitle': '正在处理来源',
  'addSourceDialog.processing.batchDescription': '正在处理 {total} 个来源。这可能需要一些时间。',
  'addSourceDialog.processing.singleDescription': '正在处理你的来源。这可能需要一些时间。',
  'addSourceDialog.processing.label': '处理中...',
  'addSourceDialog.processing.completed': '{completed} 已完成',
  'addSourceDialog.processing.failed': '{failed} 失败',
  'addSourceDialog.processing.currentItem': '当前: {currentItem}',
  'addSourceDialog.actions.cancel': '取消',
  'addSourceDialog.actions.back': '返回',
  'addSourceDialog.actions.next': '下一步',
  'addSourceDialog.actions.creating': '创建中...',
  'addSourceDialog.actions.done': '完成',
  'addSourceDialog.type.link.label': '链接',
  'addSourceDialog.type.link.description': '添加网页或 URL',
  'addSourceDialog.type.upload.label': '上传',
  'addSourceDialog.type.upload.description': '上传文档或文件',
  'addSourceDialog.type.text.label': '文本',
  'addSourceDialog.type.text.description': '直接添加文本内容',
  'addSourceDialog.type.title': '来源类型',
  'addSourceDialog.type.description': '选择添加内容的方式',
  'addSourceDialog.type.link.labelUrl': 'URL(s) *',
  'addSourceDialog.type.link.urlCount': '{count} 个 URL',
  'addSourceDialog.type.link.urlCount_plural': '{count} 个 URL',
  'addSourceDialog.type.maxSize': '最多 {size}',
  'addSourceDialog.type.link.placeholder': '输入 URL，每行一个\nhttps://example.com/article1\nhttps://example.com/article2',
  'addSourceDialog.type.link.batchHint': '粘贴多个 URL（每行一个）以批量导入',
  'addSourceDialog.type.link.invalidUrlError': '检测到无效的 URL：',
  'addSourceDialog.type.link.line': '行 {line}',
  'addSourceDialog.type.link.fixInvalidUrlHint': '请修正或移除无效的 URL 以继续',
  'addSourceDialog.type.upload.labelFile': '文件 *',
  'addSourceDialog.type.upload.fileCount': '{count} 个文件',
  'addSourceDialog.type.upload.fileCount_plural': '{count} 个文件',
  'addSourceDialog.type.upload.batchHint': '选择多个文件以批量导入。支持：文档 (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), 媒体 (MP4, MP3, WAV, M4A), 图片 (JPG, PNG), 压缩包 (ZIP)',
  'addSourceDialog.type.upload.selectedFiles': '已选文件:',
  'addSourceDialog.type.upload.fileSize': '{size} KB',
  'addSourceDialog.type.upload.maxSizeError': '每批次最多允许 {size} 个文件',
  'addSourceDialog.type.text.labelContent': '文本内容 *',
  'addSourceDialog.type.text.placeholder': '在此处粘贴或输入内容...',
  'addSourceDialog.title.required': '标题 *',
  'addSourceDialog.title.optional': '标题 (可选)',
  'addSourceDialog.title.textHint': '文本内容需要标题',
  'addSourceDialog.title.genericHint': '如果留空，将根据内容生成标题',
  'addSourceDialog.title.placeholder': '为你的来源起一个描述性的标题',
  'addSourceDialog.batchMode.title': '批量模式',
  'addSourceDialog.batchMode.description': '将处理 {count} 个 {type}',
  'addSourceDialog.batchMode.hint': '将为每个来源自动生成标题。相同的笔记本和转换将应用于所有项目。',
  'addSourceDialog.step2.notebooks.title': '选择笔记本 (可选)',
  'addSourceDialog.step2.notebooks.description': '选择包含此来源的笔记本。你可以选择多个笔记本或留空。',
  'addSourceDialog.step2.notebooks.empty': '未找到笔记本。',
  'addSourceDialog.step3.transformations.title': '转换 (可选)',
  'addSourceDialog.step3.transformations.description': '应用 AI 转换来分析和提取内容中的洞见。',
  'addSourceDialog.step3.transformations.empty': '未找到转换。',
  'addSourceDialog.step3.processing.title': '处理设置',
  'addSourceDialog.step3.processing.description': '配置来源的处理和存储方式。',
  'addSourceDialog.step3.processing.embed.label': '启用向量化以便搜索',
  'addSourceDialog.step3.processing.embed.description': '允许此来源在向量搜索和 AI 查询中被找到',
  'addSourceDialog.step3.processing.embed.auto.label': '自动启用向量化',
  'addSourceDialog.step3.processing.embed.auto.description': '你的设置已配置为始终对内容进行向量化以便搜索。你可以在 {settingsLink} 中更改此设置。',
  'addSourceDialog.step3.processing.embed.disabled.label': '向量化已禁用',
  'addSourceDialog.step3.processing.embed.disabled.description': '你的设置已配置为跳过向量化。此来源将无法用于向量搜索。你可以在 {settingsLink} 中更改此设置。',
  'addSourceDialog.error.noTransformationModel': '无法创建洞见，因为未选择语言模型。请在模型页面配置一个。',
  'addSourceDialog.step3.processing.graphrag.label': '启用知识图谱索引 (GraphRAG)',
  'addSourceDialog.step3.processing.graphrag.description': '构建实体和关系图谱，支持复杂问答和知识发现',
}

const addExistingSourceDialog = {
  'addExistingSourceDialog.title': '添加已有来源',
  'addExistingSourceDialog.description': '搜索并选择已有来源以添加到此笔记本',
  'addExistingSourceDialog.searchPlaceholder': '搜索来源...',
  'addExistingSourceDialog.loading': '正在加载来源...',
  'addExistingSourceDialog.noResults': '未找到来源',
  'addExistingSourceDialog.untitled': '无标题',
  'addExistingSourceDialog.linked': '已关联',
  'addExistingSourceDialog.addedOn': '添加于 {date}',
  'addExistingSourceDialog.truncationWarning': '仅显示前 100 个来源。请使用搜索功能查找特定来源。',
  'addExistingSourceDialog.selectionCount': '已选择 {count} 个来源',
  'addExistingSourceDialog.selectionCount_plural': '已选择 {count} 个来源',
  'addExistingSourceDialog.actions.cancel': '取消',
  'addExistingSourceDialog.actions.adding': '添加中...',
  'addExistingSourceDialog.actions.addSelected': '添加所选',
}

const createNotebookDialog = {
  'createNotebookDialog.title': '创建新笔记本',
  'createNotebookDialog.description': '为相关的来源和笔记创建一个专属空间，开始组织你的研究。',
  'createNotebookDialog.name.label': '名称 *',
  'createNotebookDialog.name.placeholder': '输入笔记本名称',
  'createNotebookDialog.name.required': '名称不能为空',
  'createNotebookDialog.description.label': '描述',
  'createNotebookDialog.description.placeholder': '描述此笔记本的用途和范围...',
  'createNotebookDialog.actions.cancel': '取消',
  'createNotebookDialog.actions.creating': '创建中…',
  'createNotebookDialog.actions.create': '创建笔记本',
}

const collapsibleColumn = {
  'collapsibleColumn.expand': '展开 {label}',
  'collapsibleColumn.collapse': '折叠 {label}',
}

const modelsPage = {
  'models.page.loadError': '模型数据加载失败',
  'models.page.title': '模型管理',
  'models.page.description': '配置 FishOwn Agent 中用于不同目的的 AI 模型',
}

const providerStatus = {
  'providerStatus.title': 'AI 提供商',
  'providerStatus.description': '通过环境变量配置提供商以启用其模型。',
  'providerStatus.configured': '已配置 {count} 个，共 {total} 个',
  'providerStatus.noModels': '无模型',
  'providerStatus.notConfigured': '未配置',
  'providerStatus.seeLess': '收起',
  'providerStatus.seeAll': '查看全部 {count} 个提供商',
  'providerStatus.learnMore': '了解如何配置提供商 →',
  'providerStatus.type.language': '语言',
  'providerStatus.type.embedding': '向量',
  'providerStatus.type.text_to_speech': '文本转语音',
  'providerStatus.type.speech_to_text': '语音转文本',
}

const providerSettings = {
  'providerSettings.title': '配置 {provider}',
  'providerSettings.description': '输入 API 密钥和其他配置信息。',
  'providerSettings.placeholder': '输入 {key}',
  'providerSettings.noSettings': '此提供商无需配置。',
  'providerSettings.validation.required': '此项为必填。',
  'providerSettings.field.api_key': 'API Key',
  'providerSettings.field.base_url': '基础 URL',
  'providerSettings.field.timeout': '超时 (秒)',
  'providerSettings.field.max_tokens': '最大 Tokens',
  'providerSettings.field.temperature': '温度',
  'providerSettings.field.gemini_api_key': 'Gemini API Key',
  'providerSettings.field.project': '项目',
  'providerSettings.field.location': '位置',
  'providerSettings.field.credentials': '凭证 JSON 路径',
  'providerSettings.field.endpoint': '端点',
  'providerSettings.field.api_version': 'API 版本',
}

const modelTypeSection = {
  'modelTypeSection.languageModels.title': '语言模型',
  'modelTypeSection.languageModels.description': '聊天、转换和文本生成',
  'modelTypeSection.embeddingModels.title': '嵌入模型',
  'modelTypeSection.embeddingModels.description': '语义搜索和向量嵌入',
  'modelTypeSection.textToSpeech.title': '文本转语音',
  'modelTypeSection.textToSpeech.description': '从文本生成音频',
  'modelTypeSection.speechToText.title': '语音转文本',
  'modelTypeSection.speechToText.description': '将音频转录为文本',
  'modelTypeSection.filter.all': '全部',
  'modelTypeSection.noModels.configured': '未配置模型',
  'modelTypeSection.noModels.providerConfigured': '未配置 {provider} 模型',
  'modelTypeSection.noModels.badge': '无模型',
  'modelTypeSection.notConfigured.badge': '未配置',
  'modelTypeSection.showLess': '收起',
  'modelTypeSection.showMore': '显示另外 {count} 个',
  'modelTypeSection.deleteModel.title': '删除模型',
  'modelTypeSection.deleteModel.description': '确定要删除 “{name}” 吗？此操作无法撤消。',
  'modelTypeSection.deleteModel.confirm': '删除',
}

const defaultModelsSection = {
  'defaultModelsSection.title': '默认模型分配',
  'defaultModelsSection.description': '配置 FishOwn Agent 中用于不同目的的 AI 模型',
  'defaultModelsSection.chatModel.label': '聊天模型',
  'defaultModelsSection.chatModel.description': '用于聊天对话',
  'defaultModelsSection.transformationModel.label': '转换模型',
  'defaultModelsSection.transformationModel.description': '用于摘要、洞察和转换',
  'defaultModelsSection.toolsModel.label': '工具模型',
  'defaultModelsSection.toolsModel.description': '用于函数调用 - 推荐 OpenAI 或 Anthropic',
  'defaultModelsSection.largeContextModel.label': '大上下文模型',
  'defaultModelsSection.largeContextModel.description': '用于处理大型文档 - 推荐 Gemini',
  'defaultModelsSection.embeddingModel.label': '嵌入模型',
  'defaultModelsSection.embeddingModel.description': '用于语义搜索和向量嵌入',
  'defaultModelsSection.textToSpeechModel.label': '文本转语音模型',
  'defaultModelsSection.textToSpeechModel.description': '用于播客生成',
  'defaultModelsSection.speechToTextModel.label': '语音转文本模型',
  'defaultModelsSection.speechToTextModel.description': '用于音频转录',
  'defaultModelsSection.missingRequired': '缺少必需模型：{models}。FishOwn Agent 可能无法正常运行。',
  'defaultModelsSection.selectModel.required': '⚠️ 必需 - 选择一个模型',
  'defaultModelsSection.selectModel.placeholder': '选择一个模型',
  'defaultModelsSection.learnMore': '我应该选择哪个模型？→',
}

const addModelForm = {
  'addModelForm.button': '添加模型',
  'addModelForm.dialog.title': '添加 {type} 模型',
  'addModelForm.dialog.description': '从可用提供商配置新的 {type} 模型。',
  'addModelForm.noProviders': '没有可用于 {type} 模型的提供商',
  'addModelForm.provider.label': '提供商',
  'addModelForm.provider.placeholder': '选择一个提供商',
  'addModelForm.provider.required': '提供商是必需的',
  'addModelForm.name.label': '模型名称',
  'addModelForm.name.required': '模型名称是必需的',
  'addModelForm.name.placeholder.language': '例如：gpt-5-mini, claude, gemini',
  'addModelForm.name.placeholder.embedding': '例如：text-embedding-3-small',
  'addModelForm.name.placeholder.textToSpeech': '例如：tts-gpt-4o-mini-tts, tts-1-hd',
  'addModelForm.name.placeholder.speechToText': '例如：whisper-1',
  'addModelForm.name.placeholder.default': '输入模型名称',
  'addModelForm.name.azureHint': '对于 Azure，请使用部署名称作为模型名称',
  'addModelForm.actions.cancel': '取消',
  'addModelForm.actions.adding': '添加中...',
  'addModelForm.actions.addModel': '添加模型',
}

const embeddingModelChangeDialog = {
  'embeddingModelChangeDialog.title': '嵌入模型变更',
  'embeddingModelChangeDialog.description.intro': '你即将更改你的嵌入模型',
  'embeddingModelChangeDialog.description.fromTo': '从 <strong>{oldModelName}</strong> 到 <strong>{newModelName}</strong>',
  'embeddingModelChangeDialog.description.important': '重要：需要重建',
  'embeddingModelChangeDialog.description.rebuildWarning': '更改嵌入模型需要重建所有现有的嵌入以保持一致性。不重建，你的搜索可能会返回不正确或不完整的结果。',
  'embeddingModelChangeDialog.description.whatHappensNext': '接下来会发生什么：',
  'embeddingModelChangeDialog.description.updated': '你的默认嵌入模型将被更新',
  'embeddingModelChangeDialog.description.unchanged': '现有嵌入在重建前将保持不变',
  'embeddingModelChangeDialog.description.newContent': '新内容将使用新的嵌入模型',
  'embeddingModelChangeDialog.description.rebuildSoon': '你应该尽快重建嵌入',
  'embeddingModelChangeDialog.description.proceedQuestion': '你希望现在进入高级页面开始重建吗？',
  'embeddingModelChangeDialog.actions.cancel': '取消',
  'embeddingModelChangeDialog.actions.changeModelOnly': '仅更改模型',
  'embeddingModelChangeDialog.actions.changeAndRebuild': '更改并前往重建',
}

const podcasts = {
  'podcasts.page.episodeCard.status.processing': '处理中',
  'podcasts.page.episodeCard.status.completed': '已完成',
  'podcasts.page.episodeCard.status.failed': '失败',
  'podcasts.page.episodeCard.status.pending': '待处理',
  'podcasts.page.episodeCard.status.unknown': '未知',
  'podcasts.page.episodeCard.audioUnavailable': '音频不可用',
  'podcasts.page.episodeCard.profile': '配置',
  'podcasts.page.episodeCard.unknown': '未知',
  'podcasts.page.episodeCard.created': '创建于',
  'podcasts.page.episodeCard.details': '详情',
  'podcasts.page.episodeCard.unknownProfile': '未知配置',
  'podcasts.page.episodeCard.summary': '摘要',
  'podcasts.page.episodeCard.outline': '大纲',
  'podcasts.page.episodeCard.transcript': '文稿',
  'podcasts.page.episodeCard.episodeProfile': '剧集配置',
  'podcasts.page.episodeCard.outlineModel': '大纲模型',
  'podcasts.page.episodeCard.transcriptModel': '文稿模型',
  'podcasts.page.episodeCard.segments': '分段',
  'podcasts.page.episodeCard.speakerProfile': '演讲者配置',
  'podcasts.page.episodeCard.voiceId': '语音 ID',
  'podcasts.page.episodeCard.backstory': '背景',
  'podcasts.page.episodeCard.personality': '个性',
  'podcasts.page.episodeCard.briefing': '简报',
  'podcasts.page.episodeCard.segment': '分段',
  'podcasts.page.episodeCard.noDescriptionProvided': '未提供描述。',
  'podcasts.page.episodeCard.noOutlineAvailable': '无可用大纲。',
  'podcasts.page.episodeCard.speaker': '演讲者',
  'podcasts.page.episodeCard.noTranscriptAvailable': '无可用文稿。',
  'podcasts.page.episodeCard.delete': '删除',
  'podcasts.page.episodeCard.deleteEpisode': '删除剧集？',
  'podcasts.page.episodeCard.deleteEpisodeDescription': '这将永久删除“{name}”及其音频文件。',
  'podcasts.page.episodeCard.cancel': '取消',
  'podcasts.page.episodeCard.deleting': '删除中…',

  'podcasts.episodeProfiles.title': '剧集配置',
  'podcasts.episodeProfiles.description': '为你的剧集定义可复用的生成设置。',
  'podcasts.episodeProfiles.createProfile': '创建配置',
  'podcasts.episodeProfiles.noSpeakerProfileWarning': '在添加剧集配置前，请先创建一个演讲者配置。',
  'podcasts.episodeProfiles.noEpisodeProfiles': '暂无剧集配置。创建一个以开始播客生成。',
  'podcasts.episodeProfiles.noDescription': '未提供描述。',
  'podcasts.episodeProfiles.edit': '编辑',
  'podcasts.episodeProfiles.duplicate': '复制',
  'podcasts.episodeProfiles.delete': '删除',
  'podcasts.episodeProfiles.deleteProfileTitle': '删除配置？',
  'podcasts.episodeProfiles.deleteProfileDescription': '这将移除“{name}”。现有剧集将保留其数据，但新剧集将不再使用此配置。',
  'podcasts.episodeProfiles.cancel': '取消',
  'podcasts.episodeProfiles.deleting': '删除中…',
  'podcasts.episodeProfiles.outlineModel': '大纲模型',
  'podcasts.episodeProfiles.transcriptModel': '文稿模型',
  'podcasts.episodeProfiles.segments': '分段',
  'podcasts.episodeProfiles.speakerProfile': '演讲者配置',
  'podcasts.episodeProfiles.defaultBriefing': '默认简报',

  'podcasts.speakerProfiles.title': '演讲者配置',
  'podcasts.speakerProfiles.description': '为生成的剧集配置声音和个性。',
  'podcasts.speakerProfiles.createSpeaker': '创建演讲者',
  'podcasts.speakerProfiles.noSpeakerProfiles': '暂无演讲者配置。创建一个以启用剧集模板。',
  'podcasts.speakerProfiles.noDescription': '未提供描述。',
  'podcasts.speakerProfiles.usageCount': '被 {count} 个剧集使用',
  'podcasts.speakerProfiles.unused': '未使用',
  'podcasts.speakerProfiles.voiceId': '语音 ID',
  'podcasts.speakerProfiles.backstory': '背景',
  'podcasts.speakerProfiles.personality': '个性',
  'podcasts.speakerProfiles.edit': '编辑',
  'podcasts.speakerProfiles.duplicate': '复制',
  'podcasts.speakerProfiles.delete': '删除',
  'podcasts.speakerProfiles.deleteProfileTitle': '删除演讲者配置？',
  'podcasts.speakerProfiles.deleteProfileDescription': '删除“{name}”后无法撤销。',
  'podcasts.speakerProfiles.deleteDisabledWarning': '在删除此演讲者之前，请先将其从剧集配置中移除。',
  'podcasts.speakerProfiles.cancel': '取消',
  'podcasts.speakerProfiles.deleting': '删除中…',

  'podcasts.generate.title': '生成播客剧集',
  'podcasts.generate.description': '在生成新的播客剧集前，选择要包含的内容并配置剧集详情。',
  'podcasts.generate.content.title': '内容',
  'podcasts.generate.content.description': '选择要包含在此剧集中的笔记本、来源和笔记。',
  'podcasts.generate.content.itemsSelected': '已选择 {count} 个项目',
  'podcasts.generate.content.tokens': '已选择 {count} 个 token',
  'podcasts.generate.content.chars': '已选择 {count} 个字符',
  'podcasts.generate.notebooks.loading': '正在加载笔记本',
  'podcasts.generate.notebooks.empty': '未找到笔记本。在生成播客前，请先创建笔记本并添加内容。',
  'podcasts.generate.notebooks.selectionSummary': '{sources} 个来源, {notes} 条笔记',
  'podcasts.generate.notebooks.noContentSelected': '未选择内容',
  'podcasts.generate.notebooks.contentSummary': '{sources} 个来源 · {notes} 条笔记',
  'podcasts.generate.sources.title': '来源',
  'podcasts.generate.sources.empty': '此笔记本中无可用来源。',
  'podcasts.generate.sources.untitled': '无标题来源',
  'podcasts.generate.sources.type.link': '链接',
  'podcasts.generate.sources.type.file': '文件',
  'podcasts.generate.sources.status.embedded': '已嵌入',
  'podcasts.generate.sources.status.notEmbedded': '未嵌入',
  'podcasts.generate.sources.selectModePlaceholder': '选择模式',
  'podcasts.generate.notes.title': '笔记',
  'podcasts.generate.notes.empty': '此笔记本中无可用笔记。',
  'podcasts.generate.notes.untitled': '无标题笔记',
  'podcasts.generate.notes.updated': '更新于 {date}',
  'podcasts.generate.settings.title': '剧集设置',
  'podcasts.generate.settings.loading': '正在加载剧集配置',
  'podcasts.generate.settings.noProfiles': '未找到剧集配置。在生成播客前，请先创建一个剧集配置。',
  'podcasts.generate.settings.episodeProfileLabel': '剧集配置',
  'podcasts.generate.settings.episodeProfilePlaceholder': '选择一个剧集配置',
  'podcasts.generate.settings.usesSpeakerProfile': '使用演讲者配置 <strong>{name}</strong>',
  'podcasts.generate.settings.episodeNameLabel': '剧集名称',
  'podcasts.generate.settings.episodeNamePlaceholder': '例如：人工智能与工作的未来',
  'podcasts.generate.settings.additionalInstructionsLabel': '附加说明',
  'podcasts.generate.settings.additionalInstructionsPlaceholder': '任何要附加到剧集简报的补充指导...',
  'podcasts.generate.settings.additionalInstructionsDescription': '这些说明将被附加到剧集配置的默认简报中。',
  'podcasts.generate.submitting': '正在生成剧集...',
  'podcasts.generate.submit': '生成播客',
  'podcasts.generate.submitDescription': '剧集生成开始后将出现在剧集列表中。刷新列表以监控进度。',
  'podcasts.generate.sourceModes.summary': '摘要',
  'podcasts.generate.sourceModes.full': '全文内容',
  'podcasts.generate.errors.buildContext': '构建上下文失败。请检查你的选择。',
  'podcasts.generate.errors.episodeProfileRequired.title': '需要剧集配置',
  'podcasts.generate.errors.episodeProfileRequired.description': '在生成播客前，请选择一个剧集配置。',
  'podcasts.generate.errors.episodeNameRequired.title': '需要剧集名称',
  'podcasts.generate.errors.episodeNameRequired.description': '为剧集提供一个名称。',
  'podcasts.generate.errors.addContext.title': '添加上下文',
  'podcasts.generate.errors.addContext.description': '至少选择一个来源或笔记以包含在剧集中。',
  'podcasts.generate.errors.generationFailed.title': '播客生成失败',
  'podcasts.generate.errors.generationFailed.description': '请稍后重试。',

  'podcasts.episodeProfileForm.editTitle': '编辑剧集配置',
  'podcasts.episodeProfileForm.createTitle': '创建剧集配置',
  'podcasts.episodeProfileForm.description': '定义剧集应如何生成以及默认使用哪个演讲者配置。',
  'podcasts.episodeProfileForm.noSpeakers.title': '无可用演讲者配置',
  'podcasts.episodeProfileForm.noSpeakers.description': '在配置剧集配置前，请先创建一个演讲者配置。',
  'podcasts.episodeProfileForm.noModels.title': '无可用语言模型',
  'podcasts.episodeProfileForm.noModels.description': '在模型部分添加语言模型以配置大纲和文稿生成。',
  'podcasts.episodeProfileForm.nameLabel': '配置名称',
  'podcasts.episodeProfileForm.namePlaceholder': '技术讨论',
  'podcasts.episodeProfileForm.segmentsLabel': '分段',
  'podcasts.episodeProfileForm.descriptionLabel': '描述',
  'podcasts.episodeProfileForm.descriptionPlaceholder': '关于何时使用此配置的简短摘要',
  'podcasts.episodeProfileForm.speakerConfig.title': '演讲者配置',
  'podcasts.episodeProfileForm.speakerConfig.profileLabel': '演讲者配置',
  'podcasts.episodeProfileForm.speakerConfig.profilePlaceholder': '选择一个演讲者配置',
  'podcasts.episodeProfileForm.outline.title': '大纲生成',
  'podcasts.episodeProfileForm.outline.providerLabel': '提供商',
  'podcasts.episodeProfileForm.outline.providerPlaceholder': '选择提供商',
  'podcasts.episodeProfileForm.outline.modelLabel': '模型',
  'podcasts.episodeProfileForm.outline.modelPlaceholder': '选择模型',
  'podcasts.episodeProfileForm.transcript.title': '文稿生成',
  'podcasts.episodeProfileForm.transcript.providerLabel': '提供商',
  'podcasts.episodeProfileForm.transcript.providerPlaceholder': '选择提供商',
  'podcasts.episodeProfileForm.transcript.modelLabel': '模型',
  'podcasts.episodeProfileForm.transcript.modelPlaceholder': '选择模型',
  'podcasts.episodeProfileForm.defaultBriefingLabel': '默认简报',
  'podcasts.episodeProfileForm.defaultBriefingPlaceholder': '概述此剧集格式的结构、基调和目标',
  'podcasts.episodeProfileForm.cancel': '取消',
  'podcasts.episodeProfileForm.saving': '保存中…',
  'podcasts.episodeProfileForm.creating': '创建中…',
  'podcasts.episodeProfileForm.saveChanges': '保存更改',
  'podcasts.episodeProfileForm.createProfile': '创建配置',
  'podcasts.episodeProfileForm.errors.nameRequired': '名称是必需的',
  'podcasts.episodeProfileForm.errors.speakerProfileRequired': '演讲者配置是必需的',
  'podcasts.episodeProfileForm.errors.outlineProviderRequired': '大纲提供商是必需的',
  'podcasts.episodeProfileForm.errors.outlineModelRequired': '大纲模型是必需的',
  'podcasts.episodeProfileForm.errors.transcriptProviderRequired': '文稿提供商是必需的',
  'podcasts.episodeProfileForm.errors.transcriptModelRequired': '文稿模型是必需的',
  'podcasts.episodeProfileForm.errors.defaultBriefingRequired': '默认简报是必需的',
  'podcasts.episodeProfileForm.errors.segmentsInteger': '必须是整数',
  'podcasts.episodeProfileForm.errors.segmentsMin': '至少 3 个分段',
  'podcasts.episodeProfileForm.errors.segmentsMax': '最多 20 个分段',

  'podcasts.speakerProfileForm.editTitle': '编辑演讲者配置',
  'podcasts.speakerProfileForm.createTitle': '创建演讲者配置',
  'podcasts.speakerProfileForm.description': '配置文本转语音设置并定义最多四个演讲者。',
  'podcasts.speakerProfileForm.noModels.title': '无可用文本转语音模型',
  'podcasts.speakerProfileForm.noModels.description': '在创建演讲者配置前，请在模型部分添加 TTS 模型。',
  'podcasts.speakerProfileForm.profileNameLabel': '配置名称',
  'podcasts.speakerProfileForm.profileNamePlaceholder': '每周节目主持人',
  'podcasts.speakerProfileForm.providerLabel': '提供商',
  'podcasts.speakerProfileForm.providerPlaceholder': '选择提供商',
  'podcasts.speakerProfileForm.modelLabel': '模型',
  'podcasts.speakerProfileForm.modelPlaceholder': '选择模型',
  'podcasts.speakerProfileForm.descriptionLabel': '描述',
  'podcasts.speakerProfileForm.descriptionPlaceholder': '关于基调、品牌或用法的说明',
  'podcasts.speakerProfileForm.speakers.title': '演讲者',
  'podcasts.speakerProfileForm.speakers.description': '为此配置配置一到四个声音。',
  'podcasts.speakerProfileForm.speakers.add': '添加演讲者',
  'podcasts.speakerProfileForm.speakers.speaker': '演讲者 {index}',
  'podcasts.speakerProfileForm.speakers.remove': '移除',
  'podcasts.speakerProfileForm.speakers.nameLabel': '名称',
  'podcasts.speakerProfileForm.speakers.namePlaceholder': '主持人 1',
  'podcasts.speakerProfileForm.speakers.voiceIdLabel': '语音 ID',
  'podcasts.speakerProfileForm.speakers.voiceIdPlaceholder': 'voice_123',
  'podcasts.speakerProfileForm.speakers.backstoryLabel': '背景',
  'podcasts.speakerProfileForm.speakers.backstoryPlaceholder': '演讲者的简短传记或背景',
  'podcasts.speakerProfileForm.speakers.personalityLabel': '个性',
  'podcasts.speakerProfileForm.speakers.personalityPlaceholder': '描述风格和基调',
  'podcasts.speakerProfileForm.cancel': '取消',
  'podcasts.speakerProfileForm.saving': '保存中…',
  'podcasts.speakerProfileForm.creating': '创建中…',
  'podcasts.speakerProfileForm.saveChanges': '保存更改',
  'podcasts.speakerProfileForm.createProfile': '创建配置',
  'podcasts.speakerProfileForm.errors.nameRequired': '名称是必需的',
  'podcasts.speakerProfileForm.errors.voiceIdRequired': '语音 ID 是必需的',
  'podcasts.speakerProfileForm.errors.backstoryRequired': '背景是必需的',
  'podcasts.speakerProfileForm.errors.personalityRequired': '个性是必需的',
  'podcasts.speakerProfileForm.errors.profileNameRequired': '名称是必需的',
  'podcasts.speakerProfileForm.errors.providerRequired': '提供商是必需的',
  'podcasts.speakerProfileForm.errors.modelRequired': '模型是必需的',
  'podcasts.speakerProfileForm.errors.atLeastOneSpeaker': '至少需要一名演讲者',
  'podcasts.speakerProfileForm.errors.maxFourSpeakers': '你最多可以配置 4 名演讲者',
}

const transformations = {
  'transformations.page.title': '转换',
  'transformations.page.description': '转换是用于处理源数据、提取见解、生成摘要等的提示。',
  'transformations.page.workspace_label': '选择工作区',
  'transformations.page.tabs.transformations': '转换',
  'transformations.page.tabs.playground': '演练场',

  'transformations.card.default_badge': '默认',
  'transformations.card.playground_button': '演练场',
  'transformations.card.edit_button': '编辑',
  'transformations.card.title_label': '标题',
  'transformations.card.untitled': '无标题',
  'transformations.card.description_label': '描述',
  'transformations.card.prompt_label': '提示',
  'transformations.card.delete_dialog.title': '删除转换',
  'transformations.card.delete_dialog.description': '您确定要删除“{name}”吗？此操作无法撤销。',
  'transformations.card.delete_dialog.confirm_text': '删除',

  'transformations.default_prompt_editor.title': '默认转换提示',
  'transformations.default_prompt_editor.description': '这将添加到您所有的转换提示中',
  'transformations.default_prompt_editor.placeholder': '输入您的默认转换说明...',
  'transformations.default_prompt_editor.save_button': '保存',

  'transformations.list.empty_state.title': '暂无转换',
  'transformations.list.empty_state.description': '创建您的第一个转换以处理和提取内容中的见解。',
  'transformations.list.empty_state.cta': '创建新转换',
  'transformations.list.title': '您的转换',
  'transformations.list.create_button': '创建新转换',

  'transformations.playground.title': '演练场',
  'transformations.playground.description': '在将转换应用于源数据之前，先在示例文本上测试它们',
  'transformations.playground.transformation_label': '转换',
  'transformations.playground.transformation_placeholder': '选择一个转换',
  'transformations.playground.model_label': '模型',
  'transformations.playground.model_placeholder': '选择一个模型',
  'transformations.playground.input_label': '输入文本',
  'transformations.playground.input_placeholder': '输入一些要转换的文本...',
  'transformations.playground.running_button': '运行中...',
  'transformations.playground.run_button': '运行转换',
  'transformations.playground.output_label': '输出',

  'transformations.editor_dialog.errors.name_required': '名称为必填项',
  'transformations.editor_dialog.errors.prompt_required': '提示为必填项',
  'transformations.editor_dialog.title_edit': '编辑转换',
  'transformations.editor_dialog.title_create': '创建转换',
  'transformations.editor_dialog.loading': '正在加载转换…',
  'transformations.editor_dialog.name_label': '名称',
  'transformations.editor_dialog.name_placeholder': '唯一标识符，例如 key_topics',
  'transformations.editor_dialog.title_label': '标题',
  'transformations.editor_dialog.title_placeholder': '显示的标题，默认为名称',
  'transformations.editor_dialog.apply_default_label': '在新源上默认建议',
  'transformations.editor_dialog.description_label': '描述',
  'transformations.editor_dialog.description_placeholder': '描述此转换的功能。',
  'transformations.editor_dialog.prompt_label': '提示',
  'transformations.editor_dialog.prompt_placeholder': '编写将为此转换提供支持的提示...',
  'transformations.editor_dialog.prompt_help_text': '编写提示时应考虑源内容。您可以要求模型进行总结、提取见解或生成结构化输出，例如表格。',
  'transformations.editor_dialog.cancel_button': '取消',
  'transformations.editor_dialog.saving_button': '保存中…',
  'transformations.editor_dialog.creating_button': '创建中…',
  'transformations.editor_dialog.save_button': '保存转换',
  'transformations.editor_dialog.create_button': '创建转换',
}

const digitalEmployeesPage = {
  'digital_employees.title': '数字员工',
  'digital_employees.description': '管理您的数字员工。',
  'digital_employees.view.table': '表格',
  'digital_employees.view.cards': '卡片',

  'digital_employees.table.empty': '暂无数字员工',
  'digital_employees.table.select_all': '全选',
  'digital_employees.table.select_row': '选择行',
  'digital_employees.table.serial': '设备序列号',
  'digital_employees.table.name': '名称',
  'digital_employees.table.login': '登录',
  'digital_employees.table.type': '业务类型',
  'digital_employees.table.mode': '设备模式',
  'digital_employees.table.available': '可用',
  'digital_employees.table.status': '状态',
  'digital_employees.table.expired_at': '过期时间',
  'digital_employees.table.control': '控制',

  'digital_employees.type.1': '小红书达人',
  'digital_employees.type.2': '视频号达人',
  'digital_employees.type.3': 'TK 达人',
  'digital_employees.type.4': '微信加好友',
  'digital_employees.type.5': '抖音 KOL',
  'digital_employees.type.12': '邮件群发',
  'digital_employees.type.14': 'BOSS 直聘',
  'digital_employees.type.16': '企微私域',
  'digital_employees.type.17': '千牛',
  'digital_employees.type.18': '个微云手机',
  'digital_employees.type.19': '小红书群截流',

  'digital_employees.status.init': '初始化',
  'digital_employees.status.op_too_frequent': '操作过于频繁',
  'digital_employees.status.login': '已登录',
  'digital_employees.status.captcha': '验证码',
  'digital_employees.status.account_exception': '账号状态异常',
  'digital_employees.status.exception': '设备状态异常',
  'digital_employees.status.account_rest': '账号休息时间',
  'digital_employees.status.task': '任务中',
  'digital_employees.status.need_clear_data': '需要清理数据',
  'digital_employees.status.account_restricted': '账号被限制',
  'digital_employees.status.unknown': '未知状态',

  'digital_employees.login.yes': '已登录',
  'digital_employees.login.no': '未登录',
  'digital_employees.available.yes': '可用',
  'digital_employees.available.no': '不可用',
  'digital_employees.mode.otg': 'OTG',
  'digital_employees.mode.usb': 'USB',

  'digital_employees.action.mirror': '投屏',
  'digital_employees.action.remove': '移除',

  'digital_employees.batch.selected': '已选择 {count} 项',
  'digital_employees.batch.delete': '批量删除',
  'digital_employees.batch.delete_confirm_title': '确认批量删除？',
  'digital_employees.batch.delete_confirm_description': '即将删除 {count} 个数字员工，此操作不可撤销。',
  'digital_employees.refresh': '刷新',

  'digital_employees.filters.name_placeholder': '名称',
  'digital_employees.filters.status_placeholder': '状态',
  'digital_employees.filters.status_all': '全部状态',

  'digital_employees.pagination.total': '共 {count} 个',
  'digital_employees.pagination.page_size': '每页数量',
  'digital_employees.pagination.per_page': '每页 {count} 个',
  'digital_employees.pagination.prev': '上一页',
  'digital_employees.pagination.next': '下一页',
  'digital_employees.pagination.page': '第 {page} / {total} 页',
  'digital_employees.add': '新增数字员工',
  'digital_employees.dialog.title': '新增数字员工',
  'digital_employees.dialog.title_edit': '更新设备',
  'digital_employees.dialog.description': '填写信息以添加新的数字员工。',
  'digital_employees.dialog.submit': '创建',
  'digital_employees.dialog.submit_update': '更新',
  'digital_employees.dialog.creating': '创建中…',
  'digital_employees.dialog.updating': '更新中…',
  'digital_employees.dialog.cancel': '取消',
  'digital_employees.dialog.fields.serial_number': '设备序列号',
  'digital_employees.dialog.fields.area': '设备区域',
  'digital_employees.dialog.fields.area_placeholder': '请选择设备区域',
  'digital_employees.dialog.fields.device_mode': '设备模式',
  'digital_employees.dialog.fields.device_mode_otg': 'OTG',
  'digital_employees.dialog.fields.device_mode_usb': 'USB',
  'digital_employees.dialog.fields.forward_port': '端口映射',
  'digital_employees.dialog.fields.remark': '备注',
  'digital_employees.dialog.fields.available': '设备是否可用',
  'digital_employees.dialog.fields.tags': '标签',
  'digital_employees.dialog.fields.tags_placeholder': '用空格分隔，例如 测试 KOL',
  'digital_employees.toast.create_success': '数字员工创建成功',
  'digital_employees.toast.update_success': '设备更新成功',
  'digital_employees.toast.delete_success': '数字员工已移除',
  'digital_employees.toast.create_error': '创建数字员工失败',
  'digital_employees.toast.update_error': '更新设备失败',
  'digital_employees.toast.delete_error': '移除数字员工失败',
  'digital_employees.delete_confirm_title': '确认删除？',
  'digital_employees.delete_confirm_description': '即将永久删除 {name}（{id}），此操作不可撤回。',
}

const agentsPage = {
  'agents.title': '智能体',
  'agents.description': '管理您的智能体。',
  'agents.searchPlaceholder': '搜索智能体…',
  'agents.searchClear': '清空搜索',
  'agents.categoryPlaceholder': '分类',
  'agents.category.all': '全部分类',
  'agents.refresh': '刷新',
  'agents.retry': '重试',
  'agents.loadError.title': '加载智能体失败',
  'agents.loadError.description': '请检查连接后重试。',
  'agents.empty.title': '暂无智能体',
  'agents.empty.description': '可尝试调整搜索关键词或分类筛选。',
  'agents.premium': '精品智能体',
  'agents.viewDetail': '查看详情',
  'agents.download': '下载',
  'agents.download.missing': '该智能体暂不提供下载。',
  'agents.download.unsupported': '暂不支持当前平台的下载。',
  'agents.download.started': '开始下载',
  'agents.launch': '配置',
  'agents.login': '登录',
  'agents.launch.toast': '配置：{name}',
  'agents.details.summary': '简介',
  'agents.details.features': '功能亮点',

  'agents.category.AIGC': 'AIGC',
  'agents.category.KOL': 'KOL挖掘',
  'agents.category.Flow': '工作流',
  'agents.category.Shop': '电商工具',
  'agents.category.Common': '通用工具',
  'agents.category.quntool': '私域工具',

  'agents.plateType.AIGC': 'AIGC',
  'agents.plateType.KOL': 'KOL挖掘',
  'agents.plateType.Flow': '工作流',
  'agents.plateType.Shop': '电商工具',
  'agents.plateType.Common': '通用工具',
  'agents.plateType.quntool': '私域工具',

  'agents.plate.1': '拉新获客',
  'agents.plate.2': '私域运营',
}

const workflowsPage = {
  'workflows.title': '工作流',
  'workflows.description': '管理您的工作流。',
  'workflows.toast.createGroupFailed': '创建分组失败',
  'workflows.toast.updateGroupFailed': '更新分组失败',
  'workflows.toast.emptyGroupSuccess': '解散成功',
  'workflows.toast.emptyGroupFailed': '解散分组失败',
  'workflows.toast.deleteGroupSuccess': '删除成功',
  'workflows.toast.deleteGroupFailed': '删除分组失败',
  'workflows.toast.createWorkflowFailed': '创建工作流失败',
  'workflows.toast.saveSuccess': '保存成功',
  'workflows.toast.saveFailed': '保存失败',
  'workflows.toast.lockedSuccess': '锁定成功',
  'workflows.toast.unlockedSuccess': '解锁成功',
  'workflows.toast.operationFailed': '操作失败',
  'workflows.toast.copySuccess': '复制成功',
  'workflows.toast.copyFailed': '复制失败',
  'workflows.toast.deleteSuccess': '删除成功',
  'workflows.toast.deleteFailed': '删除失败',
  'workflows.toast.moveFailed': '移动失败',
}

const advancedPage = {
  'advanced.page.title': '高级',
  'advanced.page.description': '为高级用户提供的工具和实用程序',

  'advanced.rebuild.title': '重建向量',
  'advanced.rebuild.description': '为您的内容重建向量。在切换嵌入模型或修复损坏的向量时使用此功能。',
  'advanced.rebuild.mode.label': '重建模式',
  'advanced.rebuild.mode.existing.label': '仅限现有',
  'advanced.rebuild.mode.all.label': '全部',
  'advanced.rebuild.mode.existing.description': '仅重新嵌入已有向量的项目（速度更快，适用于模型切换）',
  'advanced.rebuild.mode.all.description': '重新嵌入现有项目 + 为没有向量的项目创建向量（速度较慢，更全面）',
  'advanced.rebuild.include.label': '重建范围',
  'advanced.rebuild.include.sources': '来源',
  'advanced.rebuild.include.notes': '笔记',
  'advanced.rebuild.include.insights': '见解',
  'advanced.rebuild.include.error': '请至少选择一种要重建的项目类型',
  'advanced.rebuild.cta.loading': '正在开始重建...',
  'advanced.rebuild.cta.default': '开始重建',
  'advanced.rebuild.start_error': '启动重建失败：{message}',
  'advanced.rebuild.unknown_error': '未知错误',
  'advanced.rebuild.status.queued': '排队中',
  'advanced.rebuild.status.running': '运行中...',
  'advanced.rebuild.status.completed': '已完成！',
  'advanced.rebuild.status.failed': '失败',
  'advanced.rebuild.status.running_description': '您可离开此页面，重建将在后台运行',
  'advanced.rebuild.cta.new': '开始新的重建',
  'advanced.rebuild.progress.label': '进度',
  'advanced.rebuild.progress.stats': '{processed}/{total} 项 ({percent}%)',
  'advanced.rebuild.progress.failed': '⚠️ {count} 个项目处理失败',
  'advanced.rebuild.stats.time': '时间',
  'advanced.rebuild.stats.started': '开始于',
  'advanced.rebuild.stats.completed': '完成于',
  'advanced.rebuild.help.when.trigger': '我应该何时重建向量？',
  'advanced.rebuild.help.when.title': '您应该在以下情况重建向量：',
  'advanced.rebuild.help.when.item1.title': '切换嵌入模型时：',
  'advanced.rebuild.help.when.item1.description': '如果从一个嵌入模型切换到另一个，需要重建所有向量以确保一致性。',
  'advanced.rebuild.help.when.item2.title': '升级模型版本时：',
  'advanced.rebuild.help.when.item2.description': '更新到新版嵌入模型时，重建以利用改进。',
  'advanced.rebuild.help.when.item3.title': '修复损坏的向量时：',
  'advanced.rebuild.help.when.item3.description': '如果怀疑某些向量损坏或丢失，重建可以恢复它们。',
  'advanced.rebuild.help.when.item4.title': '批量导入后：',
  'advanced.rebuild.help.when.item4.description': '如果导入的内容没有向量，使用“全部”模式为所有内容嵌入向量。',
  'advanced.rebuild.help.time.trigger': '重建需要多长时间？',
  'advanced.rebuild.help.time.title': '处理时间取决于：',
  'advanced.rebuild.help.time.item1': '要处理的项目数量',
  'advanced.rebuild.help.time.item2': '嵌入模型速度',
  'advanced.rebuild.help.time.item3': 'API 速率限制（针对云提供商）',
  'advanced.rebuild.help.time.item4': '系统资源',
  'advanced.rebuild.help.time.rates_title': '典型速率：',
  'advanced.rebuild.help.time.rate1.title': '本地模型',
  'advanced.rebuild.help.time.rate1.description': '（Ollama）：非常快，仅受硬件限制',
  'advanced.rebuild.help.time.rate2.title': '云 API',
  'advanced.rebuild.help.time.rate2.description': '（OpenAI, Google）：速度适中，处理大数据集时可能达到速率限制',
  'advanced.rebuild.help.time.rate3.title': '来源：',
  'advanced.rebuild.help.time.rate3.description': '比笔记/见解慢（每个来源创建多个块）',
  'advanced.rebuild.help.time.example': '示例：使用云 API 重建 200 个项目可能需要 2-5 分钟，使用本地模型则不到 1 分钟。',
  'advanced.rebuild.help.safe.trigger': '在使用应用时重建是否安全？',
  'advanced.rebuild.help.safe.title': '是的，重建是安全的！',
  'advanced.rebuild.help.safe.item1.title': '是幂等的：',
  'advanced.rebuild.help.safe.item1.description': '多次运行产生相同结果',
  'advanced.rebuild.help.safe.item2.title': '不删除内容：',
  'advanced.rebuild.help.safe.item2.description': '仅替换向量',
  'advanced.rebuild.help.safe.item3.title': '可随时运行：',
  'advanced.rebuild.help.safe.item3.description': '无需停止其他操作',
  'advanced.rebuild.help.safe.item4.title': '优雅处理错误：',
  'advanced.rebuild.help.safe.item4.description': '失败的项目会被记录并跳过',
  'advanced.rebuild.help.safe.warning.title': '但是：',
  'advanced.rebuild.help.safe.warning.description': '非常大的重建（数千个项目）可能会在处理期间暂时减慢搜索速度。',

  'advanced.system_info.title': '系统信息',
  'advanced.system_info.loading': '加载中...',
  'advanced.system_info.current_version': '当前版本',
  'advanced.system_info.unknown': '未知',
  'advanced.system_info.latest_version': '最新版本',
  'advanced.system_info.status': '状态',
  'advanced.system_info.update_available': '有可用更新',
  'advanced.system_info.up_to_date': '已是最新',
  'advanced.system_info.view_on_website': '在官网上查看',
  'advanced.system_info.update_check_failed': '无法检查更新。更新服务器可能无法访问。',

  'advanced.jobs.title': '任务队列',
  'advanced.jobs.description': '监控后台任务和作业',
  'advanced.jobs.empty': '暂无任务',
  'advanced.jobs.columns.status': '状态',
  'advanced.jobs.columns.type': '类型',
  'advanced.jobs.columns.details': '详情',
  'advanced.jobs.columns.created': '创建时间',
  'advanced.jobs.columns.started': '开始时间',
  'advanced.jobs.columns.duration': '耗时',
  'advanced.jobs.total': '共 {count} 条',
  'advanced.jobs.columns.actions': '操作',
  'advanced.jobs.actions.retry': '重试',
  'advanced.jobs.status.new': '新建',
  'advanced.jobs.status.running': '运行中',
  'advanced.jobs.status.completed': '已完成',
  'advanced.jobs.status.failed': '失败',
  'advanced.jobs.status.canceled': '取消',
  'advanced.jobs.source_filter_placeholder': '按来源筛选',
  'advanced.jobs.all_sources': '全部来源',
}

const sourceCard = {
  'sourceCard.status.new.label': '新建',
  'sourceCard.status.new.description': '数据源已创建',
  'sourceCard.status.queued.label': '排队中',
  'sourceCard.status.queued.description': '等待处理',
  'sourceCard.status.running.label': '处理中',
  'sourceCard.status.running.description': '正在处理内容',
  'sourceCard.status.completed.label': '已完成',
  'sourceCard.status.completed.description': '处理完成',
  'sourceCard.status.failed.label': '失败',
  'sourceCard.status.failed.description': '处理失败',
  'sourceCard.untitled': '无标题数据源',
  'sourceCard.checking': '检查状态...',
  'sourceCard.type.link': '链接',
  'sourceCard.type.upload': '文件',
  'sourceCard.type.text': '文本',
  'sourceCard.type.unknown': '未知',
  'sourceCard.insights': '{count} 个洞见',
  'sourceCard.moreTopics': '+{count} 更多',
  'sourceCard.actions.removeFromNotebook': '从笔记本移除',
  'sourceCard.actions.retry': '重试处理',
  'sourceCard.actions.rebuildVectorFailed': '重建失败向量任务',
  'sourceCard.actions.rebuildGraphFailed': '重建失败图谱任务',
  'sourceCard.actions.delete': '删除数据源',
  'sourceCard.rebuild.vector.loading': '正在重建向量...',
  'sourceCard.rebuild.vector.success': '向量任务已重新构建',
  'sourceCard.rebuild.vector.error': '向量任务重建失败',
  'sourceCard.rebuild.graph.loading': '正在重建图谱...',
  'sourceCard.rebuild.graph.success': '图谱任务已重新构建',
  'sourceCard.rebuild.graph.error': '图谱任务重建失败',
  'sourceCard.progress': '处理进度',
  'sourceCard.embed': '嵌入',
  'sourceCard.graphrag': '图谱',
  'sourceCard.graphragProgress': '图谱进度',
}

const sourceDetail = {
  'sourceDetail.error.load': '加载数据源详情失败',
  'sourceDetail.error.selectTransformation': '请选择一个转换',
  'sourceDetail.success.insightCreated': '洞见创建成功',
  'sourceDetail.error.createInsight': '创建洞见失败',
  'sourceDetail.success.titleUpdated': '数据源标题已更新',
  'sourceDetail.error.updateTitle': '更新数据源标题失败',
  'sourceDetail.error.embed': '嵌入内容失败',
  'sourceDetail.success.downloadStarted': '下载已开始',
  'sourceDetail.error.fileUnavailable': '服务器上不再提供原始文件',
  'sourceDetail.error.download': '下载文件失败',
  'sourceDetail.success.urlCopied': 'URL 已复制到剪贴板',
  'sourceDetail.confirm.delete': '确定要删除此数据源吗？',
  'sourceDetail.success.delete': '数据源删除成功',
  'sourceDetail.error.delete': '删除数据源失败',
  'sourceDetail.notFound': '未找到数据源',
  'sourceDetail.title.placeholder': '数据源标题',
  'sourceDetail.title.untitled': '无标题数据源',
  'sourceDetail.sourceId': '数据源 ID: {id}',
  'sourceDetail.chat': '与数据源对话',
  'sourceDetail.file.unavailable': '文件不可用',
  'sourceDetail.file.preparing': '准备下载中…',
  'sourceDetail.file.download': '下载文件',
  'sourceDetail.embed.embedding': '正在嵌入...',
  'sourceDetail.embed.alreadyEmbedded': '已嵌入',
  'sourceDetail.embed.action': '嵌入内容',
  'sourceDetail.delete': '删除数据源',
  'sourceDetail.tabs.content': '内容',
  'sourceDetail.tabs.insights': '洞见',
  'sourceDetail.tabs.details': '详情',
  'sourceDetail.youtube.open': '在 YouTube 上打开',
  'sourceDetail.content.empty': '暂无内容',
  'sourceDetail.insights.description': '关于此数据源的 AI 生成洞见',
  'sourceDetail.insights.generate': '生成新洞见',
  'sourceDetail.insights.selectTransformation': '选择一个转换...',
  'sourceDetail.insights.creating': '创建中...',
  'sourceDetail.insights.create': '创建',
  'sourceDetail.insights.empty.title': '暂无洞见',
  'sourceDetail.insights.empty.description': '使用上方的转换创建您的第一个洞见',
  'sourceDetail.insights.view': '查看洞见',
  'sourceDetail.insights.confirmDeleteTitle': '删除此洞见？',
  'sourceDetail.insights.confirmDeleteDescription': '此操作无法撤销，请确认。',
  'sourceDetail.alert.notEmbedded.title': '内容未嵌入',
  'sourceDetail.alert.notEmbedded.description': '此内容尚未嵌入以进行向量搜索。嵌入可启用高级搜索功能和更好的内容发现。',
  'sourceDetail.alert.graphNotBuilt.title': '知识图谱未构建',
  'sourceDetail.alert.graphNotBuilt.description': '此内容尚未构建知识图谱（GraphRAG）。构建图谱可实现更深层次的实体关系分析和复杂问答。',
  'sourceDetail.graphrag.building': '正在构建...',
  'sourceDetail.graphrag.alreadyBuilt': '已构建',
  'sourceDetail.graphrag.action': '构建知识图谱',
  'sourceDetail.graphrag.progress': '图谱构建进度',
  'sourceDetail.graphrag.failed': '失败任务 {count} 个',
  'sourceDetail.error.buildGraph': '构建知识图谱失败',
  'sourceDetail.url': 'URL',
  'sourceDetail.uploadedFile': '已上传文件',
  'sourceDetail.file.unavailableButton': '不可用',
  'sourceDetail.file.preparingButton': '准备中…',
  'sourceDetail.file.downloadButton': '下载',
  'sourceDetail.file.unavailableDescription': '服务器上不再提供原始文件（可能在处理后已删除）。如果需要新副本，请再次上传。',
  'sourceDetail.topics': '主题',
  'sourceDetail.metadata': '元数据',
  'sourceDetail.metadata.embedded': '已嵌入',
  'sourceDetail.metadata.notEmbedded': '未嵌入',
  'sourceDetail.metadata.graphBuilt': '图谱已构建',
  'sourceDetail.metadata.graphNotBuilt': '图谱未构建',
  'sourceDetail.metadata.entityCount': '{count} 个实体',
  'sourceDetail.metadata.created': '创建于',
  'sourceDetail.metadata.updated': '更新于',
  'sourceDetail.type.unknown': '未知',
  'sourceDetail.type.link': '链接',
  'sourceDetail.type.file': '文件',
  'sourceDetail.type.text': '文本',
}

const streamingResponse = {
  'streamingResponse.error.notFound': '找不到此{type}',
  'streamingResponse.ariaLabel': '提问回答',
  'streamingResponse.strategy.title': '策略',
  'streamingResponse.strategy.reasoning': '推理：',
  'streamingResponse.strategy.searchTerms': '搜索词：',
  'streamingResponse.individualAnswers': '单独回答 ({count})',
  'streamingResponse.finalAnswer': '最终回答',
  'streamingResponse.processing': '正在处理您的问题...',
}

const advancedModelsDialog = {
  'advancedModelsDialog.title': '高级模型选择',
  'advancedModelsDialog.description': '为提问过程的每个阶段选择特定模型',
  'advancedModelsDialog.strategyModel.label': '策略模型',
  'advancedModelsDialog.strategyModel.placeholder': '选择策略模型',
  'advancedModelsDialog.answerModel.label': '回答模型',
  'advancedModelsDialog.answerModel.placeholder': '选择回答模型',
  'advancedModelsDialog.finalAnswerModel.label': '最终回答模型',
  'advancedModelsDialog.finalAnswerModel.placeholder': '选择最终回答模型',
  'advancedModelsDialog.cancel': '取消',
  'advancedModelsDialog.save': '保存更改',
}

const saveToNotebooksDialog = {
  'saveToNotebooksDialog.title': '保存到笔记本',
  'saveToNotebooksDialog.description': '选择一个或多个笔记本以保存此回答',
  'saveToNotebooksDialog.error.selectNotebook': '请至少选择一个笔记本',
  'saveToNotebooksDialog.success.saved': '回答已保存到 {count} 个笔记本',
  'saveToNotebooksDialog.error.saveFailed': '保存回答失败',
  'saveToNotebooksDialog.empty': '未找到笔记本。请先创建一个笔记本。',
  'saveToNotebooksDialog.cancel': '取消',
  'saveToNotebooksDialog.saving': '保存中...',
  'saveToNotebooksDialog.save': '保存到 {count} 个笔记本',
}

const modelsToast = {
  'models.toast.create.success.title': '成功',
  'models.toast.create.success.description': '模型创建成功',
  'models.toast.create.error.title': '错误',
  'models.toast.create.error.description': '创建模型失败',
  'models.toast.delete.success.title': '成功',
  'models.toast.delete.success.description': '模型删除成功',
  'models.toast.delete.error.title': '错误',
  'models.toast.delete.error.description': '删除模型失败',
  'models.toast.updateDefaults.success.title': '成功',
  'models.toast.updateDefaults.success.description': '默认模型更新成功',
  'models.toast.updateDefaults.error.title': '错误',
  'models.toast.updateDefaults.error.description': '更新默认模型失败',
  'models.toast.updateProviderSettings.success.title': '成功',
  'models.toast.updateProviderSettings.success.description': '提供商设置更新成功',
  'models.toast.updateProviderSettings.error.title': '错误',
  'models.toast.updateProviderSettings.error.description': '更新提供商设置失败',
}

const xhsqunToast = {
  'xhsqun.autojoin.toast.selectWorkflow': '请选择工作流',
  'xhsqun.autojoin.toast.invalidDailyJoinLimit': '每日加群初始下限不能等于大于最终上限',
  'xhsqun.autojoin.toast.saveFailed': '保存失败',
  'xhsqun.autojoin.toast.selectDeviceGroup': '请选择设备分组',
  'xhsqun.autojoin.toast.saveSuccess': '保存成功',
  'xhsqun.autojoin.toast.operationFailed': '操作失败',
  'xhsqun.autojoin.toast.deviceIdCopied': '已复制设备ID',
  'xhsqun.autojoin.toast.copyFailed': '复制失败',
  'xhsqun.autojoin.toast.invalidGroupSizeLimit': '群人数下限不能等于大于上限',
  'xhsqun.autojoin.toast.stopSuccess': '停止任务成功',
  'xhsqun.autojoin.toast.startSuccess': '启动任务成功',
  'xhsqun.autojoin.toast.loadFailed': '加载失败',
  'xhsqun.autojoin.toast.operationSuccess': '操作成功',
}

const dykolToast = {
  'dykol.deviceGroups.toast.createSuccess': '创建成功',
  'dykol.deviceGroups.toast.createFailed': '创建失败',
  'dykol.deviceGroups.toast.updateSuccess': '更新成功',
  'dykol.deviceGroups.toast.updateFailed': '更新失败',
  'dykol.deviceGroups.toast.deleteSuccess': '删除成功',
  'dykol.deviceGroups.toast.deleteFailed': '删除失败',
  'dykol.deviceGroups.toast.enterGroupName': '请输入分组名称',
  'dykol.task.toast.createSuccess': '任务创建成功',
  'dykol.task.toast.createFailed': '创建失败',
}

const xhsqunPrivateToast = {
  'xhsqun.private.toast.saveSuccess': '保存成功',
  'xhsqun.private.toast.saveFailed': '保存失败',
  'xhsqun.private.toast.selectWorkflow': '请选择工作流',
  'xhsqun.private.toast.loadFailed': '加载失败',
  'xhsqun.private.toast.operationFailed': '操作失败',
  'xhsqun.private.toast.paused': '已暂停',
  'xhsqun.private.toast.resumed': '已恢复',
  'xhsqun.private.toast.deviceIdCopied': '已复制设备ID',
  'xhsqun.private.toast.copyFailed': '复制失败',
}

const emailTemplateToast = {
  'email.template.toast.deleteSuccess': '删除成功',
  'email.template.toast.deleteFailed': '删除失败',
  'email.template.toast.createHint': '模版创建页尚未迁移，请暂时在旧系统创建。',
  'email.template.toast.editHint': '模版编辑页尚未迁移，请暂时在旧系统编辑。',
}

const emailRenewToast = {
  'email.renew.toast.purchaseSuccess': '购买成功',
  'email.renew.toast.purchaseFailed': '购买失败',
  'email.renew.toast.statusUpdateSuccess': '修改状态成功',
  'email.renew.toast.statusUpdateFailed': '修改状态失败',
  'email.renew.toast.enterSearchKeyword': '请输入搜索关键词',
  'email.renew.toast.searchFailed': '搜索失败',
  'email.renew.toast.selectDomain': '请选择要购买的域名',
  'email.renew.toast.rechargeHint': '充值入口尚未迁移，请前往旧系统。',
  'email.renew.toast.enterPurchaseQuantity': '购买数量不能为空',
}

const gnkeyToast = {
  'gnkey.page.toast.loadFailed': '加载失败',
  'gnkey.page.toast.deleteSuccess': '删除成功',
  'gnkey.page.toast.deleteFailed': '删除失败',
  'gnkey.create.toast.openSuccess': '开通成功',
  'gnkey.create.toast.openFailed': '开通失败',
  'gnkey.create.toast.noSceneId': '未返回 sceneId',
}

const emailCustomerToast = {
  'email.customer.toast.addSuccess': '添加成功',
  'email.customer.toast.addFailed': '添加失败',
  'email.customer.toast.updateSuccess': '修改成功',
  'email.customer.toast.updateFailed': '修改失败',
  'email.customer.toast.deleteSuccess': '删除成功',
  'email.customer.toast.deleteFailed': '删除失败',
  'email.customer.toast.cleanSuccess': '邮箱清洗成功',
  'email.customer.toast.cleanFailed': '邮箱清洗失败',
  'email.customer.toast.importSuccess': '导入成功',
  'email.customer.toast.importFailed': '导入失败',
  'email.customer.toast.enterName': '请输入名称',
  'email.customer.toast.selectFile': '请选择上传文件',
  'email.customer.toast.noEmailsToClean': '当前表单内暂无需要清洗的邮箱。',
  'email.customer.toast.insufficientQuota': '清洗额度不足，请前往续费管理购买。',
  'email.customer.toast.createTaskHint': '任务创建页尚未迁移，请暂时在旧系统创建。',
}

const emailTaskToast = {
  'email.task.toast.info': '提示信息',
  'email.task.toast.updateFailed': '更新失败',
  'email.task.toast.deleteSuccess': '删除成功',
  'email.task.toast.deleteFailed': '删除失败',
  'email.task.toast.createHint': '任务创建页尚未迁移，请暂时在旧系统创建。',
  'email.task.toast.detailHint': '任务详情页尚未迁移，请暂时在旧系统查看。',
  'email.task.toast.editHint': '任务编辑页尚未迁移，请暂时在旧系统编辑。',
}

const workflowsToast = {
  'workflows.toast.createGroupFailed': '创建分组失败',
  'workflows.toast.updateGroupFailed': '更新分组失败',
  'workflows.toast.emptyGroupSuccess': '解散成功',
  'workflows.toast.emptyGroupFailed': '解散分组失败',
  'workflows.toast.deleteGroupSuccess': '删除成功',
  'workflows.toast.deleteGroupFailed': '删除分组失败',
  'workflows.toast.createWorkflowFailed': '创建工作流失败',
  'workflows.toast.saveSuccess': '保存成功',
  'workflows.toast.saveFailed': '保存失败',
  'workflows.toast.lockedSuccess': '锁定成功',
  'workflows.toast.unlockedSuccess': '解锁成功',
  'workflows.toast.operationFailed': '操作失败',
  'workflows.toast.copySuccess': '复制成功',
  'workflows.toast.copyFailed': '复制失败',
  'workflows.toast.deleteSuccess': '删除成功',
  'workflows.toast.deleteFailed': '删除失败',
  'workflows.toast.moveFailed': '移动失败',
}

const gzhkolMonitorToast = {
  'gzhkol.monitor.toast.loadFailed': '加载失败',
  'gzhkol.monitor.toast.operationSuccess': '操作成功',
  'gzhkol.monitor.toast.operationFailed': '操作失败',
}

const gzhkolResourceToast = {
  'gzhkol.resource.toast.operationSuccess': '操作成功',
  'gzhkol.resource.toast.operationFailed': '操作失败',
  'gzhkol.resource.toast.updateSuccess': '修改成功',
  'gzhkol.resource.toast.updateFailed': '修改失败',
  'gzhkol.resource.checkLink.toast.loadFailed': '加载失败',
}

const dykolTask = {
  'dykol.task.status.pending': '待执行',
  'dykol.task.status.running': '进行中...',
  'dykol.task.status.completed': '已完成',
  'dykol.task.status.paused': '已暂停',
  'dykol.task.time.justNow': '刚刚',
  'dykol.task.time.minutesAgo': '{minutes}分钟前',
  'dykol.task.time.minutesLater': '{minutes}分钟后',
  'dykol.task.time.hoursAgo': '{hours}小时前',
  'dykol.task.time.hoursLater': '{hours}小时后',
  'dykol.task.time.daysAgo': '{days}天前',
  'dykol.task.time.daysLater': '{days}天后',
  'dykol.task.create.title': '创建任务',
  'dykol.task.create.wizard': '任务向导',
  'dykol.task.statistic.title': '任务统计',
  'dykol.task.statistic.totalMatched': '历史入库人数',
  'dykol.task.statistic.todayMatched': '今日入库人数',
  'dykol.task.statistic.lastUpdated': '最近一次更新时间',
  'dykol.task.statistic.matchRate': '入库率',
  'dykol.task.unit.person': '人',
  'dykol.task.list.title': '挖掘任务',
  'dykol.task.list.count': '当前任务数 {count}',
  'dykol.task.search.placeholder': '搜索任务名称',
  'dykol.task.filter.status': '任务状态',
  'dykol.task.filter.all': '全部状态',
  'dykol.task.filter.pending': '待执行',
  'dykol.task.filter.running': '进行中',
  'dykol.task.filter.completed': '已完成',
  'dykol.task.filter.paused': '已暂停',
  'dykol.task.filter.clear': '清空',
  'dykol.task.list.loading': '加载中...',
  'dykol.task.list.empty': '暂无任务',
  'dykol.task.list.loadingMore': '加载更多...',
  'dykol.task.list.noMore': '没有更多了',
  'dykol.task.toast.loadFailed': '加载失败',
  'dykol.task.toast.deleteSuccess': '删除成功',
  'dykol.task.toast.pauseSuccess': '暂停成功',
  'dykol.task.toast.resumeSuccess': '恢复成功',
  'dykol.task.toast.operationFailed': '操作失败',
  'dykol.task.action.delete': '删除',
  'dykol.task.action.pause': '暂停',
  'dykol.task.action.resume': '恢复',
  'dykol.task.confirm.deleteDescription': '删除后无法恢复，请谨慎操作。',
  'dykol.task.confirm.actionDescription': '确定{action}当前任务？',
  'dykol.task.card.status': '状态：{status}',
  'dykol.task.card.devices': '使用{count}台设备',
  'dykol.task.card.lastMatched': '最近入库：{time}',
  'dykol.task.card.actions': '操作',
  'dykol.task.card.resumeTask': '恢复任务',
  'dykol.task.card.pauseTask': '暂停任务',
  'dykol.task.card.deleteTask': '删除任务',
  'dykol.task.card.progress': '进度',
  'dykol.task.card.matchedCount': '入库人数',
  'dykol.task.card.collectedCount': '已采集人数',
  'dykol.task.confirm.title': '确认{action}',
}

const notebooksToast = {
  'notebooks.toast.create.success.title': '成功',
  'notebooks.toast.create.success.description': '笔记本创建成功',
  'notebooks.toast.create.error.title': '错误',
  'notebooks.toast.create.error.description': '创建笔记本失败',
  'notebooks.toast.update.success.title': '成功',
  'notebooks.toast.update.success.description': '笔记本更新成功',
  'notebooks.toast.update.error.title': '错误',
  'notebooks.toast.update.error.description': '更新笔记本失败',
  'notebooks.toast.delete.success.title': '成功',
  'notebooks.toast.delete.success.description': '笔记本删除成功',
  'notebooks.toast.delete.error.title': '错误',
  'notebooks.toast.delete.error.description': '删除笔记本失败',
}

const emailTaskPage = {
  'email.task.stats.totalSend': '累计投送',
  'email.task.stats.todaySend': '今日投送',
  'email.task.stats.todaySuccess': '今日触达数量',
  'email.task.stats.totalClick': '今日点击数量',
  'email.task.stats.unit': '人',
  'email.task.create.title': '创建任务',
  'email.task.create.button': '立即创建任务',
  'email.task.create.toast.title': '提示',
  'email.task.stats.title': '任务统计',
  'email.task.list.title': '任务列表',
  'email.task.list.total': '共 {count} 条',
  'email.task.filter.status.placeholder': '任务状态',
  'email.task.filter.status.all': '全部状态',
  'email.task.filter.search.placeholder': '搜索任务名称',
  'email.task.filter.clear': '清空',
  'email.task.list.loading': '加载中...',
  'email.task.list.empty': '暂无任务',
  'email.task.list.header.name': '任务名称',
  'email.task.list.header.status': '运行状态',
  'email.task.list.header.totalEmail': '邮箱总数',
  'email.task.list.header.cleanRate': '清洗成功率',
  'email.task.list.header.sendProgress': '投送进度',
  'email.task.list.header.metrics': '触达/阅读/点击',
  'email.task.list.header.createdAt': '创建时间',
  'email.task.list.header.actions': '操作',
  'email.task.metrics.reach': '触达',
  'email.task.metrics.read': '阅读',
  'email.task.metrics.click': '点击',
  'email.task.delete.title': '删除任务',
  'email.task.delete.description': '任务名称《{name}》，删除后无法恢复，请谨慎操作。',
  'email.task.delete.confirm': '删除',
}

const notesToast = {
  'notes.toast.create.success.title': '成功',
  'notes.toast.create.success.description': '笔记创建成功',
  'notes.toast.create.error.title': '错误',
  'notes.toast.create.error.description': '创建笔记失败',
  'notes.toast.update.success.title': '成功',
  'notes.toast.update.success.description': '笔记更新成功',
  'notes.toast.update.error.title': '错误',
  'notes.toast.update.error.description': '更新笔记失败',
  'notes.toast.delete.success.title': '成功',
  'notes.toast.delete.success.description': '笔记删除成功',
  'notes.toast.delete.error.title': '错误',
  'notes.toast.delete.error.description': '删除笔记失败',
}

const podcastsToast = {
  'podcasts.toast.deleteEpisode.success.title': '剧集已删除',
  'podcasts.toast.deleteEpisode.success.description': '播客剧集已成功移除。',
  'podcasts.toast.deleteEpisode.error.title': '删除剧集失败',
  'podcasts.toast.deleteEpisode.error.description': '请重试或查看服务器日志以获取详情。',
  'podcasts.toast.createProfile.success.title': '剧集配置已创建',
  'podcasts.toast.createProfile.success.description': '新剧集配置已准备就绪。',
  'podcasts.toast.createProfile.error.title': '创建剧集配置失败',
  'podcasts.toast.createProfile.error.description': '请检查表单并重试。',
  'podcasts.toast.updateProfile.success.title': '剧集配置已更新',
  'podcasts.toast.updateProfile.success.description': '更改已成功保存。',
  'podcasts.toast.updateProfile.error.title': '更新剧集配置失败',
  'podcasts.toast.updateProfile.error.description': '请稍后重试。',
  'podcasts.toast.deleteProfile.success.title': '剧集配置已删除',
  'podcasts.toast.deleteProfile.success.description': '配置已成功移除。',
  'podcasts.toast.deleteProfile.error.title': '删除剧集配置失败',
  'podcasts.toast.deleteProfile.error.description': '请确保该配置未被使用并重试。',
  'podcasts.toast.duplicateProfile.success.title': '剧集配置已复制',
  'podcasts.toast.duplicateProfile.success.description': '配置副本已创建。',
  'podcasts.toast.duplicateProfile.error.title': '复制剧集配置失败',
  'podcasts.toast.duplicateProfile.error.description': '请稍后重试。',
  'podcasts.toast.createSpeaker.success.title': '演讲者配置已创建',
  'podcasts.toast.createSpeaker.success.description': '演讲者配置已准备就绪。',
  'podcasts.toast.createSpeaker.error.title': '创建演讲者配置失败',
  'podcasts.toast.createSpeaker.error.description': '请检查表单并重试。',
  'podcasts.toast.updateSpeaker.success.title': '演讲者配置已更新',
  'podcasts.toast.updateSpeaker.success.description': '更改已成功保存。',
  'podcasts.toast.updateSpeaker.error.title': '更新演讲者配置失败',
  'podcasts.toast.updateSpeaker.error.description': '请稍后重试。',
  'podcasts.toast.deleteSpeaker.success.title': '演讲者配置已删除',
  'podcasts.toast.deleteSpeaker.success.description': '配置已成功移除。',
  'podcasts.toast.deleteSpeaker.error.title': '删除演讲者配置失败',
  'podcasts.toast.deleteSpeaker.error.description': '请确保该配置未被使用并重试。',
  'podcasts.toast.duplicateSpeaker.success.title': '演讲者配置已复制',
  'podcasts.toast.duplicateSpeaker.success.description': '配置副本已创建。',
  'podcasts.toast.duplicateSpeaker.error.title': '复制演讲者配置失败',
  'podcasts.toast.duplicateSpeaker.error.description': '请稍后重试。',
  'podcasts.toast.generate.success.title': '播客生成已开始',
  'podcasts.toast.generate.success.description': '剧集 “{name}” 正在创建中。',
  'podcasts.toast.generate.error.title': '启动播客生成失败',
  'podcasts.toast.generate.error.description': '请稍后重试。',
}

const searchToast = {
  'search.toast.error.title': '搜索失败',
  'search.toast.error.description': '搜索时发生错误',
}

const settingsToast = {
  'settings.toast.update.success.title': '成功',
  'settings.toast.update.success.description': '设置更新成功',
  'settings.toast.update.error.title': '错误',
  'settings.toast.update.error.description': '更新设置失败',
}

const sourcesToast = {
  'sources.toast.create.queued.title': '来源已排队',
  'sources.toast.create.queued.description': '来源已提交后台处理。您可以在来源列表中监控进度。',
  'sources.toast.create.success.title': '成功',
  'sources.toast.create.success.description': '来源添加成功',
  'sources.toast.create.error.title': '错误',
  'sources.toast.create.error.description': '添加来源失败',
  'sources.toast.update.success.title': '成功',
  'sources.toast.update.success.description': '来源更新成功',
  'sources.toast.update.error.title': '错误',
  'sources.toast.update.error.description': '更新来源失败',
  'sources.toast.delete.success.title': '成功',
  'sources.toast.delete.success.description': '来源删除成功',
  'sources.toast.delete.error.title': '错误',
  'sources.toast.delete.error.description': '删除来源失败',
  'sources.toast.upload.success.title': '成功',
  'sources.toast.upload.success.description': '文件上传成功',
  'sources.toast.upload.error.title': '错误',
  'sources.toast.upload.error.description': '文件上传失败',
  'sources.toast.retry.success.title': '来源重试已排队',
  'sources.toast.retry.success.description': '来源已重新加入处理队列。',
  'sources.toast.retry.error.title': '重试失败',
  'sources.toast.retry.error.description': '无法重试来源处理。请重试。',
  'sources.toast.addToNotebook.success.title': '成功',
  'sources.toast.addToNotebook.success.description': '已将 {count} 个来源添加到笔记本',
  'sources.toast.addToNotebook.error.title': '错误',
  'sources.toast.addToNotebook.error.description': '无法将来源添加到笔记本',
  'sources.toast.addToNotebook.partial.title': '部分成功',
  'sources.toast.addToNotebook.partial.description': '已添加 {successes} 个来源，{failures} 个失败',
  'sources.toast.removeFromNotebook.success.title': '成功',
  'sources.toast.removeFromNotebook.success.description': '已成功从笔记本移除来源',
  'sources.toast.removeFromNotebook.error.title': '错误',
  'sources.toast.removeFromNotebook.error.description': '无法从笔记本移除来源',
}

const transformationsToast = {
  'transformations.toast.create.success.title': '成功',
  'transformations.toast.create.success.description': '转换创建成功',
  'transformations.toast.create.error.title': '错误',
  'transformations.toast.create.error.description': '创建转换失败',
  'transformations.toast.update.success.title': '成功',
  'transformations.toast.update.success.description': "转换 '{name}' 保存成功",
  'transformations.toast.update.error.title': '错误',
  'transformations.toast.update.error.description': '更新转换失败',
  'transformations.toast.delete.success.title': '成功',
  'transformations.toast.delete.success.description': '转换删除成功',
  'transformations.toast.delete.error.title': '错误',
  'transformations.toast.delete.error.description': '删除转换失败',
  'transformations.toast.execute.error.title': '错误',
  'transformations.toast.execute.error.description': '执行转换失败',
  'transformations.toast.updateDefaultPrompt.success.title': '成功',
  'transformations.toast.updateDefaultPrompt.success.description': '默认提示词保存成功',
  'transformations.toast.updateDefaultPrompt.error.title': '错误',
  'transformations.toast.updateDefaultPrompt.error.description': '更新默认提示词失败',
}

const versionCheckToast = {
  'versionCheck.toast.available.title': '版本 {version} 可用',
  'versionCheck.toast.available.description': 'FishOwn Agent 有新版本可用。',
  'versionCheck.toast.available.action': '在 GitHub 上查看',
}

const chatToast = {
  'chat.toast.createSession.success': '对话会话已创建',
  'chat.toast.createSession.error': '创建对话会话失败',
  'chat.toast.updateSession.success': '会话已更新',
  'chat.toast.updateSession.error': '更新会话失败',
  'chat.toast.deleteSession.success': '会话已删除',
  'chat.toast.deleteSession.error': '删除会话失败',
  'chat.toast.sendMessage.error': '发送消息失败',
}

const commonToast = {
  'common.toast.error': '错误',
  'common.toast.success': '成功',
}

export const zhTranslations: Record<string, string> = {
  ...navigation,
  ...controls,
  ...user,
  ...settingsLanguage,
  ...settingsActions,
  ...settingsCommon,
  ...settingsContentProcessing,
  ...settingsEmbedding,
  ...settingsFiles,
  ...notebooksPage,
  ...notebooksList,
  ...notebooksCard,
  ...notebooksHeader,
  ...notebooksDetail,
  ...notebooksKnowledgeGraph,
  ...notebooksSources,
  ...notebooksNotes,
  ...notebooksChat,
  ...notebooksEditor,
  ...notebookAssociations,
  ...commonCommandPalette,
  ...commonAddButton,
  ...commonTheme,
  ...commonActions,
  ...commonConfirmDialog,
  ...commonErrorBoundary,
  ...commonConnection,
  ...commonModelSelector,
  ...modelSelectorDialog,
  ...commonContextToggle,
  ...commonContextIndicator,
  ...searchPage,
  ...sourcesPage,
  ...auth,
  ...imageGeneratorPage,
  ...podcastsPage,
  ...addSourceDialog,
  ...addExistingSourceDialog,
  ...createNotebookDialog,
  ...collapsibleColumn,
  ...modelsPage,
  ...providerStatus,
  ...providerSettings,
  ...modelTypeSection,
  ...defaultModelsSection,
  ...addModelForm,
  ...embeddingModelChangeDialog,
  ...podcasts,
  ...transformations,
  ...digitalEmployeesPage,
  ...agentsPage,
  ...workflowsPage,
  ...advancedPage,
  ...sourceCard,
  ...sourceDetail,
  ...streamingResponse,
  ...advancedModelsDialog,
  ...saveToNotebooksDialog,
  ...modelsToast,
  ...xhsqunToast,
  ...dykolToast,
  ...xhsqunPrivateToast,
  ...emailTemplateToast,
  ...emailRenewToast,
  ...gnkeyToast,
  ...emailCustomerToast,
  ...emailTaskToast,
  ...workflowsToast,
  ...gzhkolMonitorToast,
  ...gzhkolResourceToast,
  ...dykolTask,
  ...notebooksToast,
  ...emailTaskPage,
  ...notesToast,
  ...podcastsToast,
  ...searchToast,
  ...settingsToast,
  ...sourcesToast,
  ...transformationsToast,
  ...versionCheckToast,
  ...chatToast,
  ...commonToast,
}
